(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelector('.article__share-button')?.addEventListener('click', function () {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      alert('Link copied to clipboard!');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    const form = document.getElementById('blog-search-form');
    const searchInput = document.getElementById('blog-search');
    const searchButton = document.querySelector('.blog-hero__search-button');
    const loadMoreButton = document.querySelector('.blog-articles__load-more-button');
    const articlesGrid = document.getElementById('blog-articles-grid');

    function handleSearch(e) {
      e.preventDefault();
      const query = searchInput.value.trim();

      let url = new URL(window.location.href);

      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }

      window.location.href = url.toString();
    }

    if (form) {
      form.addEventListener('submit', handleSearch);
    }

    if (searchButton) {
      searchButton.addEventListener('click', handleSearch);
    }

    if (searchInput) {
      searchInput.addEventListener('keyup', function (e) {
        if (e.key === 'Enter') {
          handleSearch(e);
        }
      });
    }

    // Load More functionality
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        const loadMoreContainer = this.parentElement;
        const nextUrl = loadMoreContainer.getAttribute('data-next-url');

        if (!nextUrl) return;

        // Disable button and show loading state
        this.disabled = true;
        this.classList.add('loading');
        const originalText = this.textContent;
        this.textContent = 'Loading';

        // Fetch next page
        fetch(nextUrl, { credentials: 'same-origin' })
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Get new articles
            const newArticles = doc.querySelectorAll('#blog-articles-grid .article-card');
            newArticles.forEach((article) => {
              articlesGrid.appendChild(article);
            });

            // Check if there's another page
            const newLoadMoreContainer = doc.querySelector('.blog-articles__load-more');
            if (newLoadMoreContainer) {
              const newNextUrl = newLoadMoreContainer.getAttribute('data-next-url');
              loadMoreContainer.setAttribute('data-next-url', newNextUrl);
              this.disabled = false;
              this.classList.remove('loading');
              this.textContent = originalText;
            } else {
              // No more pages, hide button
              this.parentElement.remove();
            }
          })
          .catch((error) => {
            console.error('Error loading more articles:', error);
            this.disabled = false;
            this.classList.remove('loading');
            this.textContent = originalText;
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var cartForm = document.getElementById('cart-form');
    if (!cartForm) return;

    var moneyFormat = cartForm.getAttribute('data-money-format');
    var updateTimers = {};

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var noDecimals = Math.round(cents / 100).toString();
      var withComma = amount.replace('.', ',');
      var o = '{' + '{';
      var c = '}' + '}';
      return moneyFormat
        .replace(o + 'amount' + c, amount)
        .replace(o + 'amount_no_decimals' + c, noDecimals)
        .replace(o + 'amount_with_comma_separator' + c, withComma)
        .replace(o + 'amount_no_decimals_with_comma_separator' + c, noDecimals);
    }

    function setQuantity(input, value) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getQuantityRule(input) {
      return {
        min: parseInt(input.dataset.qtyMin, 10) || 1,
        increment: parseInt(input.dataset.qtyIncrement, 10) || 1,
        max: input.dataset.qtyMax ? parseInt(input.dataset.qtyMax, 10) : null
      };
    }

    // Snaps a quantity to the nearest valid value for the line's quantity
    // rule (min/increment/max); 0 always passes through so items can still
    // be zeroed out to remove them.
    function normalizeQuantity(value, rule) {
      if (value <= 0) return 0;

      var quantity = value < rule.min ? rule.min : value;
      var steps = Math.round((quantity - rule.min) / rule.increment);
      quantity = rule.min + steps * rule.increment;

      if (rule.max && quantity > rule.max) {
        var maxSteps = Math.floor((rule.max - rule.min) / rule.increment);
        quantity = rule.min + maxSteps * rule.increment;
      }

      return quantity;
    }

    document.querySelectorAll('.cart-table__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-index');
        var input = document.querySelector('.cart-table__qty-input[data-index="' + index + '"]');
        var rule = getQuantityRule(input);
        var val = parseInt(input.value, 10) || 0;
        if (btn.getAttribute('data-action') === 'increase') {
          var next = val <= 0 ? rule.min : val + rule.increment;
          setQuantity(input, normalizeQuantity(next, rule));
        } else if (val - rule.increment < rule.min) {
          setQuantity(input, 0);
        } else {
          setQuantity(input, normalizeQuantity(val - rule.increment, rule));
        }
      });
    });

    document.querySelectorAll('.cart-table__qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var row = input.closest('[data-cart-line]');
        if (!row) return;

        var rule = getQuantityRule(input);
        var normalized = normalizeQuantity(parseInt(input.value, 10) || 0, rule);
        input.value = normalized;

        var key = row.getAttribute('data-line-key');
        clearTimeout(updateTimers[key]);
        updateTimers[key] = setTimeout(function () {
          updateLine(row, input);
        }, 400);
      });
    });

    function updateLine(row, input) {
      var key = row.getAttribute('data-line-key');
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      var requestId = (parseInt(row.dataset.requestId || '0', 10) + 1).toString();
      row.dataset.requestId = requestId;

      row.classList.add('cart-table__row--updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function (cart) {
          if (row.dataset.requestId !== requestId) return;
          renderCart(cart, row, key);
        })
        .catch(function () {
          if (row.dataset.requestId !== requestId) return;
          row.classList.remove('cart-table__row--updating');
        });
    }

    function renderCart(cart, row, key) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) {
          item = cart.items[i];
          break;
        }
      }

      if (!item) {
        row.remove();
      } else {
        var input = row.querySelector('.cart-table__qty-input');
        if (input) input.value = item.quantity;
        var lineTotalEl = row.querySelector('[data-line-total]');
        if (lineTotalEl) lineTotalEl.textContent = formatMoney(item.final_line_price);
        row.classList.remove('cart-table__row--updating');
      }

      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      renderDiscounts(cart);

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function renderDiscounts(cart) {
      var wrap = document.querySelector('[data-cart-discounts]');
      if (!wrap) return;

      var discounts = cart.cart_level_discount_applications || [];
      wrap.textContent = '';

      discounts.forEach(function (discount) {
        var row = document.createElement('div');
        row.className = 'cart-footer__discount-row';

        var titleEl = document.createElement('span');
        titleEl.textContent = discount.title;

        var amountEl = document.createElement('span');
        amountEl.textContent = '−' + formatMoney(discount.total_allocated_amount);

        row.appendChild(titleEl);
        row.appendChild(amountEl);
        wrap.appendChild(row);
      });

      wrap.classList.toggle('cart-footer__discounts--empty', discounts.length === 0);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var form = document.getElementById('collection-filters');
    var categorySelect = document.getElementById('category-filter');
    var applicationSelect = document.getElementById('application-filter');
    var searchInput = document.getElementById('product-search');
    var searchButton = document.querySelector('.collection-hero__search-button');
    var productGrid = document.getElementById('product-grid');
    var loadMoreContainer = document.getElementById('load-more-container');
    var emptyState = document.getElementById('empty-state');

    var collectionHandle = form ? form.dataset.collectionHandle : '';
    var parentCollection = form ? form.dataset.parentCollection : '';

    /** Whether the grid is currently showing AJAX search results */
    var isShowingSearchResults = false;

    // Prevent native form submission
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    // ── Helpers ──

    /**
     * Build a collection URL and navigate (full page reload).
     * Used by category & application-type dropdowns when there is no search query.
     */
    function navigateWithFilters() {
      var categoryHandle = categorySelect ? categorySelect.value : '';
      var appType = applicationSelect ? applicationSelect.value : '';

      var targetPath;
      if (categoryHandle) {
        targetPath = '/collections/' + categoryHandle;
      } else if (parentCollection) {
        targetPath = '/collections/' + parentCollection;
      } else {
        targetPath = '/collections/' + collectionHandle;
      }

      var url = new URL(window.location.origin + targetPath);
      if (appType) {
        url.searchParams.set('filter.p.m.custom.application_type', appType);
      }

      window.location.href = url.toString();
    }

    /**
     * AJAX product search – calls /search?q=…&type=product and optionally
     * appends the application-type metafield filter.
     * Results are parsed from the search-section HTML and injected into
     * the existing product grid.
     */
    function performAjaxSearch() {
      var query = searchInput ? searchInput.value.trim() : '';

      // Empty query while showing search results → reload the collection
      if (!query) {
        if (isShowingSearchResults) {
          navigateWithFilters();
        }
        return;
      }

      var appType = applicationSelect ? applicationSelect.value : '';

      var searchUrl = new URL(window.location.origin + '/search');
      searchUrl.searchParams.set('q', query);
      searchUrl.searchParams.set('type', 'product');
      if (appType) {
        searchUrl.searchParams.set('filter.p.m.custom.application_type', appType);
      }

      // Loading state
      productGrid.innerHTML =
        '<div class="collection-products__empty" style="display:block;"><p>Searching\u2026</p></div>';
      if (loadMoreContainer) loadMoreContainer.style.display = 'none';

      fetch(searchUrl.toString(), { credentials: 'same-origin' })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // The search section renders cards inside #search-results-grid
          var searchGrid = doc.getElementById('search-results-grid');
          var cards = searchGrid ? searchGrid.querySelectorAll('.product-card-vertical') : [];

          productGrid.innerHTML = '';
          isShowingSearchResults = true;

          // Inject card styles from the search response (stripped when grid was cleared)
          var cardStyles = searchGrid ? searchGrid.querySelectorAll('style') : [];
          if (cardStyles.length > 0) {
            productGrid.appendChild(cardStyles[0].cloneNode(true));
          }

          if (cards.length > 0) {
            cards.forEach(function (card) {
              var wrapper = document.createElement('div');
              wrapper.className = 'product-wrapper';
              wrapper.appendChild(card.cloneNode(true));
              productGrid.appendChild(wrapper);
            });
            if (emptyState) emptyState.style.display = 'none';
          } else {
            if (emptyState) {
              emptyState.innerHTML =
                '<p>No products found for \u201c' + query.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '\u201d.</p>';
              emptyState.style.display = '';
              productGrid.appendChild(emptyState);
            }
          }

          // Search pagination ("Load more" from the search section)
          var searchLoadMore = doc.getElementById('search-load-more');
          var nextLink = searchLoadMore ? searchLoadMore.querySelector('a') : null;

          if (nextLink && loadMoreContainer) {
            var btn = loadMoreContainer.querySelector('a');
            if (btn) {
              btn.setAttribute('href', nextLink.getAttribute('href'));
              btn.textContent = 'Load more';
              btn.style.pointerEvents = '';
            }
            loadMoreContainer.style.display = '';
          } else if (loadMoreContainer) {
            loadMoreContainer.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.error('Search error:', err);
          productGrid.innerHTML = '';
          if (emptyState) {
            emptyState.innerHTML = '<p>An error occurred while searching. Please try again.</p>';
            emptyState.style.display = '';
            productGrid.appendChild(emptyState);
          }
        });
    }

    /**
     * AJAX Load More – works for both collection pagination and search
     * pagination. Fetches the next page, extracts product cards from
     * the response HTML and appends them to the grid.
     */
    function initLoadMore() {
      if (!loadMoreContainer) return;

      loadMoreContainer.addEventListener('click', function (e) {
        e.preventDefault();

        var link = loadMoreContainer.querySelector('a');
        if (!link) return;

        var nextUrl = link.getAttribute('href');
        if (!nextUrl) return;

        link.textContent = 'Loading\u2026';
        link.style.pointerEvents = 'none';

        fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            if (isShowingSearchResults) {
              // ── Search results pagination ──
              var searchGrid = doc.getElementById('search-results-grid');
              if (searchGrid) {
                var cards = searchGrid.querySelectorAll('.product-card-vertical');
                // Ensure card styles are present (may have been stripped on first load)
                if (!productGrid.querySelector('style') && searchGrid.querySelector('style')) {
                  productGrid.appendChild(searchGrid.querySelector('style').cloneNode(true));
                }
                cards.forEach(function (card) {
                  var wrapper = document.createElement('div');
                  wrapper.className = 'product-wrapper';
                  wrapper.appendChild(card.cloneNode(true));
                  productGrid.appendChild(wrapper);
                });
              }

              var newSearchLoadMore = doc.getElementById('search-load-more');
              var newLink = newSearchLoadMore ? newSearchLoadMore.querySelector('a') : null;

              if (newLink) {
                link.setAttribute('href', newLink.getAttribute('href'));
                link.textContent = 'Load more';
                link.style.pointerEvents = '';
              } else {
                loadMoreContainer.style.display = 'none';
              }
            } else {
              // ── Collection pagination (original behaviour) ──
              var newGrid = doc.getElementById('product-grid');
              if (newGrid) {
                var newWrappers = newGrid.querySelectorAll('.product-wrapper');
                newWrappers.forEach(function (wrapper) {
                  productGrid.appendChild(wrapper);
                });
              }

              var newLoadMore = doc.getElementById('load-more-container');
              var nextPageLink = newLoadMore ? newLoadMore.querySelector('a') : null;

              if (nextPageLink) {
                link.setAttribute('href', nextPageLink.getAttribute('href'));
                link.textContent = 'Load more';
                link.style.pointerEvents = '';
              } else {
                loadMoreContainer.remove();
              }
            }
          })
          .catch(function (err) {
            console.error('Load more error:', err);
            link.textContent = 'Load more';
            link.style.pointerEvents = '';
          });
      });
    }

    // ── Event listeners ──

    // Category dropdown → always navigate to sub-collection
    if (categorySelect) {
      categorySelect.addEventListener('change', navigateWithFilters);
    }

    // Application type dropdown → AJAX search when search field has a
    // value, otherwise navigate with the storefront filter.
    if (applicationSelect) {
      applicationSelect.addEventListener('change', function () {
        var query = searchInput ? searchInput.value.trim() : '';
        if (query) {
          performAjaxSearch();
        } else {
          navigateWithFilters();
        }
      });
    }

    // Search input Enter → AJAX search
    if (searchInput) {
      searchInput.addEventListener('keyup', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          performAjaxSearch();
        }
      });
    }

    // Search button click → AJAX search
    if (searchButton) {
      searchButton.addEventListener('click', function (e) {
        e.preventDefault();
        performAjaxSearch();
      });
    }

    initLoadMore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-carousel"] && !Shopify.designMode) return;
  try {
    
  class CTACarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-carousel-track]');
      this.slides = element.querySelectorAll('[data-carousel-slide]');
      this.progressContainer = element.querySelector('[data-carousel-progress]');
      this.progressLines = element.querySelectorAll('[data-progress-line]');
      this.prevBtn = element.querySelector('[data-carousel-prev]');
      this.nextBtn = element.querySelector('[data-carousel-next]');
      this.currentIndex = 0;
      this.autoplayInterval = null;

      this.init();
    }

    init() {
      if (this.slides.length <= 1) return;

      this.updateCarousel();
      this.attachEvents();
      this.startAutoplay();
    }

    attachEvents() {
      // Add click events to progress lines for manual navigation
      this.progressLines.forEach((line, index) => {
        line.style.cursor = 'pointer';
        line.addEventListener('click', () => {
          this.goToSlide(index);
          this.resetAutoplay();
        });
      });

      // Prev / next buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prev();
          this.resetAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.next();
          this.resetAutoplay();
        });
      }

      // Pause autoplay on hover
      this.element.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.element.addEventListener('mouseleave', () => this.startAutoplay());
    }

    goToSlide(index) {
      this.currentIndex = index;
      this.updateCarousel();
    }

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.updateCarousel();
    }

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.updateCarousel();
    }

    updateCarousel() {
      const offset = -this.currentIndex * 100;
      this.track.style.transform = `translateX(${offset}%)`;

      // Update progress lines
      this.progressLines.forEach((line, index) => {
        line.classList.toggle('cta-carousel__progress-line--active', index === this.currentIndex);
      });
    }

    startAutoplay() {
      if (this.autoplayInterval) return;
      this.autoplayInterval = setInterval(() => this.next(), 5000);
    }

    pauseAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.pauseAutoplay();
      this.startAutoplay();
    }
  }

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.cta-carousel');
    carousels.forEach((carousel) => new CTACarousel(carousel));
  });

  // Reinitialize on Shopify section events
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('.cta-carousel');
      if (carousel) {
        new CTACarousel(carousel);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Edit address buttons
    document.querySelectorAll('.customer-address__button--edit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addressId = this.getAttribute('data-address-id');
        var form = document.getElementById('address-form-' + addressId);
        if (form) {
          form.hidden = !form.hidden;
        }
      });
    });

    // Add new address button
    document.querySelectorAll('.customer-address__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById('address-form-new');
        if (form) {
          form.hidden = !form.hidden;
        }
      });
    });

    // Cancel buttons
    document.querySelectorAll('.customer-address__button--cancel').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addressId = this.getAttribute('data-address-id');
        var form = document.getElementById('address-form-' + addressId);
        if (form) {
          form.hidden = true;
        }
      });
    });

    // Delete address buttons
    document.querySelectorAll('.customer-address__button--delete').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var addressId = this.getAttribute('data-address-id');
        var confirmMessage = this.getAttribute('data-confirm-message');

        if (confirm(confirmMessage)) {
          var deleteBtn = document.getElementById('delete-' + addressId);
          if (deleteBtn) {
            deleteBtn.click();
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbx-stockist-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Haversine distance (returns miles) ---
    function haversineMiles(lat1, lon1, lat2, lon2) {
      var R = 3958.8;
      var dLat = ((lat2 - lat1) * Math.PI) / 180;
      var dLon = ((lon2 - lon1) * Math.PI) / 180;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // --- Init each section ---
    document.querySelectorAll('[id^="gbx-stockist-finder-"]').forEach(function (section) {
      var form = section.querySelector('.gbx-stockist-finder__form');
      var input = section.querySelector('.gbx-stockist-finder__input');
      var grid = section.querySelector('.gbx-stockist-finder__grid');
      var emptyState = section.querySelector('.gbx-stockist-finder__empty');
      var loadingState = section.querySelector('.gbx-stockist-finder__loading');
      var loadMoreWrap = section.querySelector('.gbx-stockist-finder__load-more');
      var loadMoreBtn = section.querySelector('.gbx-stockist-finder__load-more-button');

      var stockistsUrl = section.dataset.stockistsUrl || '';
      var apiKey = section.dataset.googleMapsKey || '';
      var searchRadius = parseFloat(section.dataset.searchRadius) || 25; // miles
      var resultsPerPage = parseInt(section.dataset.resultsPerPage, 10) || 8;

      var allStockists = []; // full geocoded dataset
      var allResults = []; // filtered + sorted after a search
      var currentPage = 0;
      var debounceTimer = null;
      var DEBOUNCE_MS = 250;
      var suggestionsList = section.querySelector('.gbx-stockist-finder__suggestions');
      var lastSearchedQuery = '';
      var activeIndex = -1;

      // Fetch stockists_gbx.json once
      if (stockistsUrl) {
        fetch(stockistsUrl, { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            allStockists = (Array.isArray(data) ? data : []).filter(function (s) {
              return s.lat != null && s.lng != null;
            });
          })
          .catch(function (err) {
            console.error('GBX stockist data failed to load:', err);
          });
      }

      // --- UI helpers ---
      function showLoading() {
        loadingState.hidden = false;
        emptyState.hidden = true;
        grid.innerHTML = '';
        loadMoreWrap.hidden = true;
      }
      function hideLoading() {
        loadingState.hidden = true;
      }
      function showEmpty() {
        emptyState.hidden = false;
        loadMoreWrap.hidden = true;
      }

      // --- Suggestions dropdown ---
      function showSuggestions(suggestions) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        suggestionsList.innerHTML = '';
        if (!suggestions.length) {
          hideSuggestions();
          return;
        }
        suggestions.forEach(function (s, i) {
          var li = document.createElement('li');
          li.className = 'gbx-stockist-finder__suggestion';
          li.textContent = s.text;
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', 'false');
          li.id = suggestionsList.id + '-option-' + i;
          li.dataset.placeId = s.placeId;
          li.addEventListener('mousedown', function (e) {
            e.preventDefault(); // keep focus on input until we're done
            input.value = s.text;
            lastSearchedQuery = s.text;
            hideSuggestions();
            showLoading();
            fetchPlaceDetails(s.placeId);
          });
          suggestionsList.appendChild(li);
        });
        suggestionsList.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function hideSuggestions() {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        suggestionsList.hidden = true;
        suggestionsList.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function setActiveIndex(items) {
        items.forEach(function (item, i) {
          item.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
          if (i === activeIndex) {
            item.scrollIntoView({ block: 'nearest' });
            input.setAttribute('aria-activedescendant', item.id);
          }
        });
        if (activeIndex < 0) input.removeAttribute('aria-activedescendant');
      }

      // --- Places Autocomplete (New REST API) ---
      function fetchSuggestions(query) {
        if (!query || query.length < 2 || !apiKey) {
          hideSuggestions();
          return;
        }
        fetch('https://places.googleapis.com/v1/places:autocomplete?key=' + apiKey, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ input: query, includedRegionCodes: ['GB'] }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var suggestions = (data.suggestions || []).map(function (s) {
              return {
                placeId: s.placePrediction.placeId,
                text: s.placePrediction.text.text,
              };
            });
            showSuggestions(suggestions);
          })
          .catch(function () {
            hideSuggestions();
          });
      }

      // --- Places Details (New REST API) — fetch lat/lng for selected place ---
      function fetchPlaceDetails(placeId) {
        fetch('https://places.googleapis.com/v1/places/' + placeId + '?fields=location&key=' + apiKey)
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.location) {
              runSearch(data.location.latitude, data.location.longitude);
            } else {
              hideLoading();
              showEmpty();
            }
          })
          .catch(function () {
            hideLoading();
            showEmpty();
          });
      }

      // --- Card builder ---
      function buildCard(s) {
        var card = document.createElement('article');
        card.className = 'gbx-stockist-finder__card';

        var name = document.createElement('h3');
        name.className = 'gbx-stockist-finder__card-name';
        name.textContent = s.name || '';
        card.appendChild(name);

        var addrParts = [s.address_1, s.address_2, s.city, s.county, s.postcode].filter(Boolean);
        if (addrParts.length) {
          var addr = document.createElement('p');
          addr.className = 'gbx-stockist-finder__card-address';
          addr.textContent = addrParts.join(', ');
          card.appendChild(addr);
        }

        if (s.phone) {
          var ph = document.createElement('p');
          ph.className = 'gbx-stockist-finder__card-phone';
          var a = document.createElement('a');
          a.href = 'tel:' + s.phone.replace(/\s/g, '');
          a.textContent = s.phone;
          ph.appendChild(a);
          card.appendChild(ph);
        }

        if (s._distance != null) {
          var dist = document.createElement('p');
          dist.className = 'gbx-stockist-finder__card-distance';
          dist.textContent = s._distance.toFixed(1) + ' miles away';
          card.appendChild(dist);
        }

        return card;
      }

      // --- Render a page of results ---
      function renderPage(append) {
        if (!append) grid.innerHTML = '';
        var start = (currentPage - 1) * resultsPerPage;
        var end = start + resultsPerPage;
        allResults.slice(start, end).forEach(function (s) {
          grid.appendChild(buildCard(s));
        });
        loadMoreWrap.hidden = end >= allResults.length;
      }

      // --- Run haversine against loaded stockists ---
      function runSearch(lat, lng) {
        var sorted = allStockists
          .map(function (s) {
            return Object.assign({}, s, { _distance: haversineMiles(lat, lng, s.lat, s.lng) });
          })
          .filter(function (s) {
            return s._distance <= searchRadius;
          })
          .sort(function (a, b) {
            return a._distance - b._distance;
          });

        allResults = sorted;

        hideLoading();
        if (allResults.length === 0) {
          showEmpty();
        } else {
          currentPage = 1;
          renderPage(false);
        }
      }

      // --- Geocoding REST API fallback (form submit without suggestion pick) ---
      function geocodeAndSearch(query) {
        if (!apiKey) {
          hideLoading();
          showEmpty();
          return;
        }
        fetch(
          'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            encodeURIComponent(query) +
            '&components=country:GB&key=' +
            apiKey
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status === 'OK' && data.results[0]) {
              var loc = data.results[0].geometry.location;
              runSearch(loc.lat, loc.lng);
            } else {
              hideLoading();
              showEmpty();
            }
          })
          .catch(function () {
            hideLoading();
            showEmpty();
          });
      }

      // --- Keyboard navigation in suggestions ---
      input.addEventListener('keydown', function (e) {
        if (suggestionsList.hidden) return;
        var items = Array.prototype.slice.call(suggestionsList.querySelectorAll('[data-place-id]'));
        if (!items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, items.length - 1);
          setActiveIndex(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, -1);
          setActiveIndex(items);
        } else if (e.key === 'Escape') {
          hideSuggestions();
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          var selected = items[activeIndex];
          input.value = selected.textContent;
          lastSearchedQuery = selected.textContent;
          hideSuggestions();
          showLoading();
          fetchPlaceDetails(selected.dataset.placeId);
        }
      });

      // --- Debounced input → autocomplete suggestions ---
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          fetchSuggestions(input.value.trim());
        }, DEBOUNCE_MS);
      });

      input.addEventListener('blur', function () {
        // Small delay so the mousedown on a suggestion fires before we hide the list
        setTimeout(hideSuggestions, 150);
      });

      // --- Form submit — pick first suggestion if visible, else geocode ---
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.trim();
        if (!q) return;

        // Query unchanged and results already displayed — do nothing
        if (q === lastSearchedQuery && allResults.length > 0) {
          hideSuggestions();
          return;
        }

        // Suggestions visible — promote the first one instead of geocoding raw text
        var firstSuggestion = suggestionsList.querySelector('[data-place-id]');
        if (firstSuggestion && !suggestionsList.hidden) {
          input.value = firstSuggestion.textContent;
          lastSearchedQuery = firstSuggestion.textContent;
          hideSuggestions();
          showLoading();
          fetchPlaceDetails(firstSuggestion.dataset.placeId);
          return;
        }

        lastSearchedQuery = q;
        hideSuggestions();
        showLoading();
        geocodeAndSearch(q);
      });

      // --- Load more ---
      loadMoreBtn.addEventListener('click', function () {
        currentPage++;
        renderPage(true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbx-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gbx-video]').forEach(function (container) {
    var video = container.querySelector('video');
    var play = container.querySelector('.gbx-video__play');
    if (!video || !play) return;

    play.addEventListener('click', function () {
      video.play();
    });
    video.addEventListener('play', function () {
      container.classList.add('is-playing');
    });
    video.addEventListener('pause', function () {
      container.classList.remove('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.querySelector('.header__mobile--trigger');
    const menu = document.querySelector('.header__right');
    const header = document.querySelector('.header');

    // Desktop dropdown hover effect for dark text
    const dropdownItems = document.querySelectorAll('.header__menu-item--has-dropdown');
    const originalDarkText = header.getAttribute('data-original-dark-text') === 'true';

    dropdownItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (window.innerWidth > 920) {
          header.setAttribute('data-dark-text', 'true');
        }
      });

      item.addEventListener('mouseleave', function () {
        if (window.innerWidth > 920) {
          if (originalDarkText) {
            header.setAttribute('data-dark-text', 'true');
          } else {
            header.removeAttribute('data-dark-text');
          }
        }
      });
    });

    if (trigger && menu) {
      trigger.addEventListener('click', function () {
        trigger.classList.toggle('is-active');
        menu.classList.toggle('is-open');
        document.body.style.overflow = menu.classList.contains('is-open') ? 'hidden' : '';
      });

      // Close menu when clicking outside
      document.addEventListener('click', function (e) {
        if (menu.classList.contains('is-open') && !menu.contains(e.target) && !trigger.contains(e.target)) {
          trigger.classList.remove('is-active');
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });

      // Close menu on window resize if open
      window.addEventListener('resize', function () {
        if (window.innerWidth > 920 && menu.classList.contains('is-open')) {
          trigger.classList.remove('is-active');
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    // Mobile dropdown toggles
    if (window.innerWidth <= 920) {
      const dropdownToggles = document.querySelectorAll('.header__menu-item--has-dropdown > a');

      dropdownToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const parent = toggle.closest('.header__menu-item--has-dropdown');
          parent.classList.toggle('is-open');
        });
      });
    }

    // Reinitialize dropdown toggles on resize
    window.addEventListener('resize', function () {
      const dropdownToggles = document.querySelectorAll('.header__menu-item--has-dropdown > a');

      dropdownToggles.forEach(function (toggle) {
        const clonedToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(clonedToggle, toggle);

        if (window.innerWidth <= 920) {
          clonedToggle.addEventListener('click', function (e) {
            e.preventDefault();
            const parent = clonedToggle.closest('.header__menu-item--has-dropdown');
            parent.classList.toggle('is-open');
          });
        }
      });
    });

    // Search overlay
    const searchBtn = document.querySelector('.header__search-btn');
    const searchOverlay = document.getElementById('headerSearchOverlay');
    const searchInput = document.getElementById('headerSearchInput');
    const searchMobileInput = document.getElementById('headerSearchMobile');
    const searchClose = searchOverlay ? searchOverlay.querySelector('.header__search-close') : null;

    function openSearch() {
      if (window.innerWidth <= 920) {
        // Open mobile drawer and focus the mobile search input
        if (trigger && menu) {
          trigger.classList.add('is-active');
          menu.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        if (searchMobileInput) {
          setTimeout(function () {
            searchMobileInput.focus();
          }, 300);
        }
      } else {
        searchOverlay.classList.add('is-open');
        searchOverlay.setAttribute('aria-hidden', 'false');
        searchInput.focus();
      }
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchInput.value = '';
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', openSearch);
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });

    document.addEventListener('click', function (e) {
      if (
        searchOverlay &&
        searchOverlay.classList.contains('is-open') &&
        !searchOverlay.contains(e.target) &&
        !searchBtn.contains(e.target)
      ) {
        closeSearch();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
      document.querySelectorAll('.hero__background-video').forEach(function (video) {
        video.querySelectorAll('source').forEach(function (s) {
          s.removeAttribute('src');
        });
        video.load();
        video.parentNode.removeChild(video);
      });
      return;
    }

    function getVideo(audience) {
      var version = document.querySelector('.hero__version[data-hero-audience="' + audience + '"]');
      return version ? version.querySelector('.hero__background-video') : null;
    }

    function suspendVideo(video) {
      if (!video) return;
      video.querySelectorAll('source').forEach(function (s) {
        if (s.src && !s.dataset.src) {
          s.dataset.src = s.src;
          s.removeAttribute('src');
        }
      });
      video.load();
    }

    function resumeVideo(video) {
      if (!video) return;
      video.querySelectorAll('source').forEach(function (s) {
        if (s.dataset.src) s.src = s.dataset.src;
      });
      video.load();
      video.play().catch(function () {});
    }

    // Suspend both videos upfront so neither competes with page resources
    suspendVideo(getVideo('trade'));
    suspendVideo(getVideo('consumer'));

    // Load the active audience video once the hero is in view
    var heroSection = document.querySelector('.hero');
    if (heroSection && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              obs.disconnect();
              resumeVideo(getVideo(document.documentElement.dataset.audience || 'trade'));
            }
          });
        },
        { rootMargin: '200px' }
      ).observe(heroSection);
    } else {
      resumeVideo(getVideo(document.documentElement.dataset.audience || 'trade'));
    }

    document.addEventListener('audience:changed', function (e) {
      var next = e.detail.audience;
      var prev = next === 'trade' ? 'consumer' : 'trade';
      suspendVideo(getVideo(prev));
      resumeVideo(getVideo(next));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MIN_GAP_DESKTOP = 100;
    var MIN_GAP_MOBILE = 40;
    var MOBILE_QUERY = '(max-width: 640px)';

    function clampOverlap(section) {
      var container = section.querySelector('.info-cards__container');
      var wrapper = section.closest('.shopify-section') || section;
      var previous = wrapper.previousElementSibling;
      if (!container || !previous) return;

      // Measure from the previous section's own content, not its outer box —
      // its bottom padding is already "spent" reaching the section boundary,
      // so anchoring there would under-count the real gap to the hero title.
      var anchor = previous.querySelector('.warranty-hero__content') || previous;

      var minGap = window.matchMedia(MOBILE_QUERY).matches ? MIN_GAP_MOBILE : MIN_GAP_DESKTOP;

      // Re-apply the configured overlap first, so this is re-derived from scratch
      // on every resize rather than compounding a previous adjustment.
      container.style.removeProperty('margin-top');

      var gap = container.getBoundingClientRect().top - anchor.getBoundingClientRect().bottom;
      if (gap >= minGap) return;

      var configuredMarginTop = parseFloat(getComputedStyle(container).marginTop) || 0;
      var adjustedMarginTop = Math.min(0, configuredMarginTop + (minGap - gap));
      container.style.marginTop = adjustedMarginTop + 'px';
    }

    function clampAll() {
      document.querySelectorAll('.info-cards--overlap').forEach(clampOverlap);
    }

    document.addEventListener('DOMContentLoaded', clampAll);
    window.addEventListener('resize', clampAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    window.fnames = new Array();
    window.ftypes = new Array();
    fnames[0] = 'EMAIL';
    ftypes[0] = 'email';
    fnames[1] = 'FNAME';
    ftypes[1] = 'text';
    fnames[2] = 'LNAME';
    ftypes[2] = 'text';
  })(jQuery);
  var $mcj = jQuery.noConflict(true);
  // SMS Phone Multi-Country Functionality
  if (!window.MC) {
    window.MC = {};
  }
  window.MC.smsPhoneData = {
    defaultCountryCode: 'GB',
    programs: [],
    smsProgramDataCountryNames: [],
  };

  function getCountryUnicodeFlag(countryCode) {
    return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
  }

  // HTML sanitization function to prevent XSS
  function sanitizeHtml(str) {
    if (typeof str !== 'string') return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  }

  // URL sanitization function to prevent javascript: and data: URLs
  function sanitizeUrl(url) {
    if (typeof url !== 'string') return '';
    const trimmedUrl = url.trim().toLowerCase();
    if (trimmedUrl.startsWith('javascript:') || trimmedUrl.startsWith('data:') || trimmedUrl.startsWith('vbscript:')) {
      return '#';
    }
    return url;
  }

  const getBrowserLanguage = () => {
    if (!window?.navigator?.language?.split('-')[1]) {
      return window?.navigator?.language?.toUpperCase();
    }
    return window?.navigator?.language?.split('-')[1];
  };

  function getDefaultCountryProgram(defaultCountryCode, smsProgramData) {
    if (!smsProgramData || smsProgramData.length === 0) {
      return null;
    }

    const browserLanguage = getBrowserLanguage();

    if (browserLanguage) {
      const foundProgram = smsProgramData.find((program) => program?.countryCode === browserLanguage);
      if (foundProgram) {
        return foundProgram;
      }
    }

    if (defaultCountryCode) {
      const foundProgram = smsProgramData.find((program) => program?.countryCode === defaultCountryCode);
      if (foundProgram) {
        return foundProgram;
      }
    }

    return smsProgramData[0];
  }

  function updateSmsLegalText(countryCode, fieldName) {
    if (!countryCode || !fieldName) {
      return;
    }

    const programs = window?.MC?.smsPhoneData?.programs;
    if (!programs || !Array.isArray(programs)) {
      return;
    }

    const program = programs.find((program) => program?.countryCode === countryCode);
    if (!program || !program.requiredTemplate) {
      return;
    }

    const legalTextElement = document.querySelector('#legal-text-' + fieldName);
    if (!legalTextElement) {
      return;
    }

    // Remove HTML tags and clean up the text
    const divRegex = new RegExp('</?[div][^>]*>', 'gi');
    const fullAnchorRegex = new RegExp('<a.*?</a>', 'g');
    const anchorRegex = new RegExp('<a href="(.*?)" target="(.*?)">(.*?)</a>');

    const template = program.requiredTemplate.replace(divRegex, '');

    legalTextElement.textContent = '';
    const parts = template.split(/(<a href=".*?" target=".*?">.*?<\/a>)/g);
    parts.forEach(function (part) {
      if (!part) {
        return;
      }
      const anchorMatch = part.match(/<a href="(.*?)" target="(.*?)">(.*?)<\/a>/);
      if (anchorMatch) {
        const linkElement = document.createElement('a');
        linkElement.href = sanitizeUrl(anchorMatch[1]);
        linkElement.target = sanitizeHtml(anchorMatch[2]);
        linkElement.textContent = sanitizeHtml(anchorMatch[3]);
        legalTextElement.appendChild(linkElement);
      } else {
        legalTextElement.appendChild(document.createTextNode(part));
      }
    });
  }

  function generateDropdownOptions(smsProgramData) {
    if (!smsProgramData || smsProgramData.length === 0) {
      return '';
    }

    var programs = false
      ? smsProgramData.filter(function (p, i, arr) {
          return (
            arr.findIndex(function (q) {
              return q.countryCode === p.countryCode;
            }) === i
          );
        })
      : smsProgramData;

    return programs
      .map((program) => {
        const flag = getCountryUnicodeFlag(program.countryCode);
        const countryName = getCountryName(program.countryCode);
        const callingCode = program.countryCallingCode || '';
        // Sanitize all values to prevent XSS
        const sanitizedCountryCode = sanitizeHtml(program.countryCode || '');
        const sanitizedCountryName = sanitizeHtml(countryName || '');
        const sanitizedCallingCode = sanitizeHtml(callingCode || '');
        return (
          '<option value="' +
          sanitizedCountryCode +
          '">' +
          sanitizedCountryName +
          ' ' +
          sanitizedCallingCode +
          '</option>'
        );
      })
      .join('');
  }

  function getCountryName(countryCode) {
    if (
      window.MC?.smsPhoneData?.smsProgramDataCountryNames &&
      Array.isArray(window.MC.smsPhoneData.smsProgramDataCountryNames)
    ) {
      for (let i = 0; i < window.MC.smsPhoneData.smsProgramDataCountryNames.length; i++) {
        if (window.MC.smsPhoneData.smsProgramDataCountryNames[i].code === countryCode) {
          return window.MC.smsPhoneData.smsProgramDataCountryNames[i].name;
        }
      }
    }
    return countryCode;
  }

  function getDefaultPlaceholder(countryCode) {
    if (!countryCode || typeof countryCode !== 'string') {
      return '+1 000 000 0000'; // Default US placeholder
    }

    var mockPlaceholders = [
      {
        countryCode: 'US',
        placeholder: '+1 000 000 0000',
        helpText: 'Include the US country code +1 before the phone number',
      },
      {
        countryCode: 'GB',
        placeholder: '+44 0000 000000',
        helpText: 'Include the GB country code +44 before the phone number',
      },
      {
        countryCode: 'CA',
        placeholder: '+1 000 000 0000',
        helpText: 'Include the CA country code +1 before the phone number',
      },
      {
        countryCode: 'AU',
        placeholder: '+61 000 000 000',
        helpText: 'Include the AU country code +61 before the phone number',
      },
      {
        countryCode: 'DE',
        placeholder: '+49 000 0000000',
        helpText: 'Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein',
      },
      {
        countryCode: 'FR',
        placeholder: '+33 0 00 00 00 00',
        helpText: 'Incluez le code pays FR +33 avant le numéro de téléphone',
      },
      {
        countryCode: 'ES',
        placeholder: '+34 000 000 000',
        helpText: 'Incluya el código de país ES +34 antes del número de teléfono',
      },
      {
        countryCode: 'NL',
        placeholder: '+31 0 00000000',
        helpText: 'Voeg de NL-landcode +31 toe vóór het telefoonnummer',
      },
      {
        countryCode: 'BE',
        placeholder: '+32 000 00 00 00',
        helpText: 'Incluez le code pays BE +32 avant le numéro de téléphone',
      },
      {
        countryCode: 'CH',
        placeholder: '+41 00 000 00 00',
        helpText: 'Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein',
      },
      {
        countryCode: 'AT',
        placeholder: '+43 000 000 0000',
        helpText: 'Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein',
      },
      {
        countryCode: 'IE',
        placeholder: '+353 00 000 0000',
        helpText: 'Include the IE country code +353 before the phone number',
      },
      {
        countryCode: 'IT',
        placeholder: '+39 000 000 0000',
        helpText: 'Includere il prefisso internazionale IT +39 prima del numero di telefono',
      },
      {
        countryCode: 'NO',
        placeholder: '+47 000 00 000',
        helpText: 'Inkluder NO landskode +47 før telefonnummeret',
      },
      {
        countryCode: 'SE',
        placeholder: '+46 00 000 00 00',
        helpText: 'Inkludera SE landskod +46 före telefonnumret',
      },
      {
        countryCode: 'DK',
        placeholder: '+45 00 00 00 00',
        helpText: 'Inkluder DK landekode +45 før telefonnummeret',
      },
      {
        countryCode: 'FI',
        placeholder: '+358 00 000 0000',
        helpText: 'Sisällytä FI-maakoodi +358 ennen puhelinnumeroa',
      },
      {
        countryCode: 'EE',
        placeholder: '+372 0000 0000',
        helpText: 'Lisage EE riigikood +372 telefoninumbri ette',
      },
      {
        countryCode: 'PL',
        placeholder: '+48 000 000 000',
        helpText: 'Podaj numer kierunkowy PL +48 przed numerem telefonu',
      },
      {
        countryCode: 'SK',
        placeholder: '+421 000 000 000',
        helpText: 'Pred telefónne číslo uveďte kód krajiny SK +421',
      },
      {
        countryCode: 'LV',
        placeholder: '+371 0000 0000',
        helpText: 'Iekļaujiet LV valsts kodu +371 pirms tālruņa numura',
      },
      {
        countryCode: 'LT',
        placeholder: '+370 0000 0000',
        helpText: 'Įtraukite LT šalies kodą +370 prieš telefono numerį',
      },
      {
        countryCode: 'GR',
        placeholder: '+30 000 000 0000',
        helpText: 'Συμπεριλάβετε τον κωδικό χώρας GR +30 πριν από τον αριθμό τηλεφώνου',
      },
      {
        countryCode: 'PT',
        placeholder: '+351 000 000 000',
        helpText: 'Inclua o código de país PT +351 antes do número de telefone',
      },
      {
        countryCode: 'HR',
        placeholder: '+385 00 000 0000',
        helpText: 'Uključite HR pozivni broj države +385 prije telefonskog broja',
      },
      {
        countryCode: 'SI',
        placeholder: '+386 00 000 000',
        helpText: 'Vključite SI kodo države +386 pred telefonsko številko',
      },
      {
        countryCode: 'IS',
        placeholder: '+354 000 0000',
        helpText: 'Láttu IS landsnúmer +354 fylgja á undan símanúmerinu',
      },
      {
        countryCode: 'LU',
        placeholder: '+352 000 000 000',
        helpText: 'Incluez le code pays LU +352 avant le numéro de téléphone',
      },
      {
        countryCode: 'MC',
        placeholder: '+377 00 00 00 00',
        helpText: 'Incluez le code pays MC +377 avant le numéro de téléphone',
      },
      {
        countryCode: 'AD',
        placeholder: '+376 000 000',
        helpText: 'Incloeu el codi de país AD +376 abans del número de telèfon',
      },
      {
        countryCode: 'JE',
        placeholder: '+44 0000 000000',
        helpText: 'Include the JE country code +44 before the phone number',
      },
      {
        countryCode: 'IM',
        placeholder: '+44 0000 000000',
        helpText: 'Include the IM country code +44 before the phone number',
      },
      {
        countryCode: 'GG',
        placeholder: '+44 0000 000000',
        helpText: 'Include the GG country code +44 before the phone number',
      },
      {
        countryCode: 'AL',
        placeholder: '+355 00 000 0000',
        helpText: 'Përfshini kodin e vendit AL +355 para numrit të telefonit',
      },
      {
        countryCode: 'SM',
        placeholder: '+378 0000 000000',
        helpText: 'Includere il prefisso internazionale SM +378 prima del numero di telefono',
      },
      {
        countryCode: 'FO',
        placeholder: '+298 000000',
        helpText: 'Inkluder FO landekode +298 før telefonnummeret',
      },
      {
        countryCode: 'MT',
        placeholder: '+356 0000 0000',
        helpText: 'Include the MT country code +356 before the phone number',
      },
      {
        countryCode: 'LI',
        placeholder: '+423 000 0000',
        helpText: 'Fügen Sie vor der Telefonnummer die LI-Ländervorwahl +423 ein',
      },
      {
        countryCode: 'GI',
        placeholder: '+350 000 00000',
        helpText: 'Include the GI country code +350 before the phone number',
      },
      {
        countryCode: 'MD',
        placeholder: '+373 00 000 000',
        helpText: 'Includeți codul de țară MD +373 înaintea numărului de telefon',
      },
      {
        countryCode: 'HU',
        placeholder: '+36 00 000 0000',
        helpText: 'A telefonszám előtt adja meg a HU országkódot +36',
      },
      {
        countryCode: 'NZ',
        placeholder: '+64 00 000 0000',
        helpText: 'Include the NZ country code +64 before the phone number',
      },
      {
        countryCode: 'ME',
        placeholder: '+382 00 000 000',
        helpText: 'Uključite ME pozivni broj države +382 prije telefonskog broja',
      },
    ];

    const selectedPlaceholder = mockPlaceholders.find(function (item) {
      return item && item.countryCode === countryCode;
    });

    return selectedPlaceholder ? selectedPlaceholder.placeholder : mockPlaceholders[0].placeholder;
  }

  function updatePlaceholder(countryCode, fieldName) {
    if (!countryCode || !fieldName) {
      return;
    }

    const phoneInput = document.querySelector('#mce-' + fieldName);
    if (!phoneInput) {
      return;
    }

    const placeholder = getDefaultPlaceholder(countryCode);
    if (placeholder) {
      phoneInput.placeholder = placeholder;
    }
  }

  function updateCountryCodeInstruction(countryCode, fieldName) {
    updatePlaceholder(countryCode, fieldName);
  }

  function getDefaultHelpText(countryCode) {
    var mockPlaceholders = [
      {
        countryCode: 'US',
        placeholder: '+1 000 000 0000',
        helpText: 'Include the US country code +1 before the phone number',
      },
      {
        countryCode: 'GB',
        placeholder: '+44 0000 000000',
        helpText: 'Include the GB country code +44 before the phone number',
      },
      {
        countryCode: 'CA',
        placeholder: '+1 000 000 0000',
        helpText: 'Include the CA country code +1 before the phone number',
      },
      {
        countryCode: 'AU',
        placeholder: '+61 000 000 000',
        helpText: 'Include the AU country code +61 before the phone number',
      },
      {
        countryCode: 'DE',
        placeholder: '+49 000 0000000',
        helpText: 'Fügen Sie vor der Telefonnummer die DE-Ländervorwahl +49 ein',
      },
      {
        countryCode: 'FR',
        placeholder: '+33 0 00 00 00 00',
        helpText: 'Incluez le code pays FR +33 avant le numéro de téléphone',
      },
      {
        countryCode: 'ES',
        placeholder: '+34 000 000 000',
        helpText: 'Incluya el código de país ES +34 antes del número de teléfono',
      },
      {
        countryCode: 'NL',
        placeholder: '+31 0 00000000',
        helpText: 'Voeg de NL-landcode +31 toe vóór het telefoonnummer',
      },
      {
        countryCode: 'BE',
        placeholder: '+32 000 00 00 00',
        helpText: 'Incluez le code pays BE +32 avant le numéro de téléphone',
      },
      {
        countryCode: 'CH',
        placeholder: '+41 00 000 00 00',
        helpText: 'Fügen Sie vor der Telefonnummer die CH-Ländervorwahl +41 ein',
      },
      {
        countryCode: 'AT',
        placeholder: '+43 000 000 0000',
        helpText: 'Fügen Sie vor der Telefonnummer die AT-Ländervorwahl +43 ein',
      },
      {
        countryCode: 'IE',
        placeholder: '+353 00 000 0000',
        helpText: 'Include the IE country code +353 before the phone number',
      },
      {
        countryCode: 'IT',
        placeholder: '+39 000 000 0000',
        helpText: 'Includere il prefisso internazionale IT +39 prima del numero di telefono',
      },
      {
        countryCode: 'NO',
        placeholder: '+47 000 00 000',
        helpText: 'Inkluder NO landskode +47 før telefonnummeret',
      },
      {
        countryCode: 'SE',
        placeholder: '+46 00 000 00 00',
        helpText: 'Inkludera SE landskod +46 före telefonnumret',
      },
      {
        countryCode: 'DK',
        placeholder: '+45 00 00 00 00',
        helpText: 'Inkluder DK landekode +45 før telefonnummeret',
      },
      {
        countryCode: 'FI',
        placeholder: '+358 00 000 0000',
        helpText: 'Sisällytä FI-maakoodi +358 ennen puhelinnumeroa',
      },
      {
        countryCode: 'EE',
        placeholder: '+372 0000 0000',
        helpText: 'Lisage EE riigikood +372 telefoninumbri ette',
      },
      {
        countryCode: 'PL',
        placeholder: '+48 000 000 000',
        helpText: 'Podaj numer kierunkowy PL +48 przed numerem telefonu',
      },
      {
        countryCode: 'SK',
        placeholder: '+421 000 000 000',
        helpText: 'Pred telefónne číslo uveďte kód krajiny SK +421',
      },
      {
        countryCode: 'LV',
        placeholder: '+371 0000 0000',
        helpText: 'Iekļaujiet LV valsts kodu +371 pirms tālruņa numura',
      },
      {
        countryCode: 'LT',
        placeholder: '+370 0000 0000',
        helpText: 'Įtraukite LT šalies kodą +370 prieš telefono numerį',
      },
      {
        countryCode: 'GR',
        placeholder: '+30 000 000 0000',
        helpText: 'Συμπεριλάβετε τον κωδικό χώρας GR +30 πριν από τον αριθμό τηλεφώνου',
      },
      {
        countryCode: 'PT',
        placeholder: '+351 000 000 000',
        helpText: 'Inclua o código de país PT +351 antes do número de telefone',
      },
      {
        countryCode: 'HR',
        placeholder: '+385 00 000 0000',
        helpText: 'Uključite HR pozivni broj države +385 prije telefonskog broja',
      },
      {
        countryCode: 'SI',
        placeholder: '+386 00 000 000',
        helpText: 'Vključite SI kodo države +386 pred telefonsko številko',
      },
      {
        countryCode: 'IS',
        placeholder: '+354 000 0000',
        helpText: 'Láttu IS landsnúmer +354 fylgja á undan símanúmerinu',
      },
      {
        countryCode: 'LU',
        placeholder: '+352 000 000 000',
        helpText: 'Incluez le code pays LU +352 avant le numéro de téléphone',
      },
      {
        countryCode: 'MC',
        placeholder: '+377 00 00 00 00',
        helpText: 'Incluez le code pays MC +377 avant le numéro de téléphone',
      },
      {
        countryCode: 'AD',
        placeholder: '+376 000 000',
        helpText: 'Incloeu el codi de país AD +376 abans del número de telèfon',
      },
      {
        countryCode: 'JE',
        placeholder: '+44 0000 000000',
        helpText: 'Include the JE country code +44 before the phone number',
      },
      {
        countryCode: 'IM',
        placeholder: '+44 0000 000000',
        helpText: 'Include the IM country code +44 before the phone number',
      },
      {
        countryCode: 'GG',
        placeholder: '+44 0000 000000',
        helpText: 'Include the GG country code +44 before the phone number',
      },
      {
        countryCode: 'AL',
        placeholder: '+355 00 000 0000',
        helpText: 'Përfshini kodin e vendit AL +355 para numrit të telefonit',
      },
      {
        countryCode: 'SM',
        placeholder: '+378 0000 000000',
        helpText: 'Includere il prefisso internazionale SM +378 prima del numero di telefono',
      },
      {
        countryCode: 'FO',
        placeholder: '+298 000000',
        helpText: 'Inkluder FO landekode +298 før telefonnummeret',
      },
      {
        countryCode: 'MT',
        placeholder: '+356 0000 0000',
        helpText: 'Include the MT country code +356 before the phone number',
      },
      {
        countryCode: 'LI',
        placeholder: '+423 000 0000',
        helpText: 'Fügen Sie vor der Telefonnummer die LI-Ländervorwahl +423 ein',
      },
      {
        countryCode: 'GI',
        placeholder: '+350 000 00000',
        helpText: 'Include the GI country code +350 before the phone number',
      },
      {
        countryCode: 'MD',
        placeholder: '+373 00 000 000',
        helpText: 'Includeți codul de țară MD +373 înaintea numărului de telefon',
      },
      {
        countryCode: 'HU',
        placeholder: '+36 00 000 0000',
        helpText: 'A telefonszám előtt adja meg a HU országkódot +36',
      },
      {
        countryCode: 'NZ',
        placeholder: '+64 00 000 0000',
        helpText: 'Include the NZ country code +64 before the phone number',
      },
      {
        countryCode: 'ME',
        placeholder: '+382 00 000 000',
        helpText: 'Uključite ME pozivni broj države +382 prije telefonskog broja',
      },
    ];

    if (!countryCode || typeof countryCode !== 'string') {
      return mockPlaceholders[0].helpText;
    }

    const selectedHelpText = mockPlaceholders.find(function (item) {
      return item && item.countryCode === countryCode;
    });

    return selectedHelpText ? selectedHelpText.helpText : mockPlaceholders[0].helpText;
  }

  function setDefaultHelpText(countryCode) {
    const helpTextSpan = document.querySelector('#help-text');
    if (!helpTextSpan) {
      return;
    }
  }

  function updateHelpTextCountryCode(countryCode, fieldName) {
    if (!countryCode || !fieldName) {
      return;
    }

    setDefaultHelpText(countryCode);
  }

  function initializeSmsPhoneDropdown(fieldName) {
    if (!fieldName || typeof fieldName !== 'string') {
      return;
    }

    const dropdown = document.querySelector('#country-select-' + fieldName);
    const displayFlag = document.querySelector('#flag-display-' + fieldName);

    if (!dropdown || !displayFlag) {
      return;
    }

    const smsPhoneData = window.MC?.smsPhoneData;
    if (smsPhoneData && smsPhoneData.programs && Array.isArray(smsPhoneData.programs)) {
      dropdown.innerHTML = generateDropdownOptions(smsPhoneData.programs);
    }

    const defaultProgram = getDefaultCountryProgram(smsPhoneData?.defaultCountryCode, smsPhoneData?.programs);
    if (defaultProgram && defaultProgram.countryCode) {
      dropdown.value = defaultProgram.countryCode;

      const flagSpan = displayFlag?.querySelector('#flag-emoji-' + fieldName);
      if (flagSpan) {
        flagSpan.textContent = getCountryUnicodeFlag(defaultProgram.countryCode);
        flagSpan.setAttribute('aria-label', sanitizeHtml(defaultProgram.countryCode) + ' flag');
      }

      updateSmsLegalText(defaultProgram.countryCode, fieldName);
      updatePlaceholder(defaultProgram.countryCode, fieldName);
      updateCountryCodeInstruction(defaultProgram.countryCode, fieldName);
    }

    var smsNotRequiredRemoveCountryCodeEnabled = true;
    var smsField = Object.values({
      FNAME: {
        name: 'FNAME',
        label: 'First Name',
        helper_text: '',
        type: 'text',
        required: false,
        audience_field_name: 'First Name',
        enabled: true,
        order: 0,
        field_type: 'merge',
        merge_id: 1,
      },
      LNAME: {
        name: 'LNAME',
        label: 'Last Name',
        helper_text: '',
        type: 'text',
        required: false,
        audience_field_name: 'Last Name',
        enabled: true,
        order: 1,
        field_type: 'merge',
        merge_id: 2,
      },
      EMAIL: {
        name: 'EMAIL',
        label: 'Email Address',
        helper_text: '',
        merge_id: 0,
        type: 'email',
        required: true,
        audience_field_name: 'Email Address',
        field_type: 'merge',
        enabled: true,
        order: 2,
      },
      ADDRESS: {
        name: 'ADDRESS',
        label: 'Address',
        helper_text: '',
        type: 'address',
        required: false,
        audience_field_name: 'Address',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 3,
        countries: {
          2: 'Albania',
          3: 'Algeria',
          4: 'Andorra',
          5: 'Angola',
          6: 'Argentina',
          7: 'Armenia',
          8: 'Australia',
          9: 'Austria',
          10: 'Azerbaijan',
          11: 'Bahamas',
          12: 'Bahrain',
          13: 'Bangladesh',
          14: 'Barbados',
          15: 'Belarus',
          16: 'Belgium',
          17: 'Belize',
          18: 'Benin',
          19: 'Bermuda',
          20: 'Bhutan',
          21: 'Bolivia',
          22: 'Bosnia and Herzegovina',
          23: 'Botswana',
          24: 'Brazil',
          25: 'Bulgaria',
          26: 'Burkina Faso',
          27: 'Burundi',
          28: 'Cambodia',
          29: 'Cameroon',
          30: 'Canada',
          31: 'Cape Verde',
          32: 'Cayman Islands',
          33: 'Central African Republic',
          34: 'Chad',
          35: 'Chile',
          36: 'China',
          37: 'Colombia',
          38: 'Congo',
          40: 'Croatia',
          41: 'Cyprus',
          42: 'Czech Republic',
          43: 'Denmark',
          44: 'Djibouti',
          45: 'Ecuador',
          46: 'Egypt',
          47: 'El Salvador',
          48: 'Equatorial Guinea',
          49: 'Eritrea',
          50: 'Estonia',
          51: 'Ethiopia',
          52: 'Fiji',
          53: 'Finland',
          54: 'France',
          56: 'Gabon',
          57: 'Gambia',
          58: 'Georgia',
          59: 'Germany',
          60: 'Ghana',
          61: 'Greece',
          62: 'Guam',
          63: 'Guinea',
          64: 'Guinea-Bissau',
          65: 'Guyana',
          66: 'Honduras',
          67: 'Hong Kong',
          68: 'Hungary',
          69: 'Iceland',
          70: 'India',
          71: 'Indonesia',
          74: 'Ireland',
          75: 'Israel',
          76: 'Italy',
          78: 'Japan',
          79: 'Jordan',
          80: 'Kazakhstan',
          81: 'Kenya',
          82: 'Kuwait',
          83: 'Kyrgyzstan',
          84: "Lao People's Democratic Republic",
          85: 'Latvia',
          86: 'Lebanon',
          87: 'Lesotho',
          88: 'Liberia',
          90: 'Liechtenstein',
          91: 'Lithuania',
          92: 'Luxembourg',
          93: 'Macedonia',
          94: 'Madagascar',
          95: 'Malawi',
          96: 'Malaysia',
          97: 'Maldives',
          98: 'Mali',
          99: 'Malta',
          100: 'Mauritania',
          101: 'Mexico',
          102: 'Moldova',
          103: 'Monaco',
          104: 'Mongolia',
          105: 'Morocco',
          106: 'Mozambique',
          107: 'Namibia',
          108: 'Nepal',
          109: 'Netherlands',
          110: 'Netherlands Antilles',
          111: 'New Zealand',
          112: 'Nicaragua',
          113: 'Niger',
          114: 'Nigeria',
          116: 'Norway',
          117: 'Oman',
          118: 'Pakistan',
          119: 'Panama',
          120: 'Paraguay',
          121: 'Peru',
          122: 'Philippines',
          123: 'Poland',
          124: 'Portugal',
          126: 'Qatar',
          127: 'Reunion',
          128: 'Romania',
          129: 'Russia',
          130: 'Rwanda',
          132: 'Samoa (Independent)',
          133: 'Saudi Arabia',
          134: 'Senegal',
          135: 'Seychelles',
          136: 'Sierra Leone',
          137: 'Singapore',
          138: 'Slovakia',
          139: 'Slovenia',
          140: 'Somalia',
          141: 'South Africa',
          142: 'South Korea',
          143: 'Spain',
          144: 'Sri Lanka',
          146: 'Suriname',
          147: 'Swaziland',
          148: 'Sweden',
          149: 'Switzerland',
          152: 'Taiwan',
          153: 'Tanzania',
          154: 'Thailand',
          155: 'Togo',
          156: 'Tunisia',
          157: 'Turkiye',
          158: 'Turkmenistan',
          159: 'Uganda',
          161: 'Ukraine',
          162: 'United Arab Emirates',
          163: 'Uruguay',
          164: 'USA',
          165: 'Uzbekistan',
          166: 'Vatican City State (Holy See)',
          167: 'Venezuela',
          168: 'Vietnam',
          169: 'Virgin Islands (British)',
          170: 'Yemen',
          173: 'Zambia',
          174: 'Zimbabwe',
          175: 'Antigua And Barbuda',
          176: 'Anguilla',
          178: 'American Samoa',
          179: 'Aruba',
          180: 'Brunei Darussalam',
          181: 'Bouvet Island',
          183: 'Cook Islands',
          185: 'Christmas Island',
          187: 'Dominican Republic',
          188: 'Western Sahara',
          189: 'Falkland Islands',
          191: 'Faroe Islands',
          192: 'Grenada',
          193: 'French Guiana',
          194: 'Gibraltar',
          195: 'Greenland',
          196: 'Guadeloupe',
          198: 'Guatemala',
          200: 'Haiti',
          202: 'Jamaica',
          203: 'Kiribati',
          204: 'Comoros',
          205: 'Saint Kitts and Nevis',
          206: 'Saint Lucia',
          207: 'Marshall Islands',
          208: 'Macau',
          210: 'Martinique',
          212: 'Mauritius',
          213: 'New Caledonia',
          214: 'Norfolk Island',
          215: 'Nauru',
          217: 'Niue',
          219: 'Papua New Guinea',
          221: 'Pitcairn',
          222: 'Palau',
          223: 'Solomon Islands',
          225: 'Svalbard and Jan Mayen Islands',
          227: 'San Marino',
          232: 'Tonga',
          233: 'Timor-Leste',
          234: 'Trinidad and Tobago',
          235: 'Tuvalu',
          237: 'Saint Vincent and the Grenadines',
          238: 'Virgin Islands (U.S.)',
          239: 'Vanuatu',
          241: 'Mayotte',
          242: 'Myanmar',
          255: 'Sao Tome and Principe',
          257: 'South Georgia and the South Sandwich Islands',
          260: 'Tajikistan',
          262: 'United Kingdom',
          268: 'Costa Rica',
          270: 'Guernsey',
          272: 'North Korea',
          274: 'Afghanistan',
          275: "Cote D'Ivoire",
          276: 'Cuba',
          277: 'French Polynesia',
          278: 'Iran',
          279: 'Iraq',
          281: 'Libya',
          282: 'Palestine',
          285: 'Syria',
          286: 'Aaland Islands',
          287: 'Turks & Caicos Islands',
          288: 'Jersey  (Channel Islands)',
          289: 'Dominica',
          290: 'Montenegro',
          293: 'Sudan',
          294: 'Montserrat',
          298: 'Curacao',
          302: 'Sint Maarten',
          311: 'South Sudan',
          315: 'Republic of Kosovo',
          318: 'Congo, Democratic Republic of the',
          323: 'Isle of Man',
          324: 'Saint Martin',
          325: 'Bonaire, Saint Eustatius and Saba',
          326: 'Serbia',
        },
        defaultcountry: 164,
      },
      PHONE: {
        name: 'PHONE',
        label: 'Phone Number',
        helper_text: '',
        type: 'phone',
        required: false,
        audience_field_name: 'Phone Number',
        phoneformat: '',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 4,
      },
      BIRTHDAY: {
        name: 'BIRTHDAY',
        label: 'Birthday',
        helper_text: '',
        type: 'birthday',
        required: false,
        audience_field_name: 'Birthday',
        dateformat: 'MM/DD',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 5,
      },
      MMERGE7: {
        name: 'MMERGE7',
        label: 'Area',
        helper_text: '',
        type: 'text',
        required: false,
        audience_field_name: 'Area',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 7,
      },
      MMERGE8: {
        name: 'MMERGE8',
        label: 'Company Name',
        helper_text: '',
        type: 'text',
        required: false,
        audience_field_name: 'Company Name',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 8,
      },
      MMERGE9: {
        name: 'MMERGE9',
        label: 'Company Code',
        helper_text: '',
        type: 'text',
        required: false,
        audience_field_name: 'Company Code',
        enabled: false,
        order: null,
        field_type: 'merge',
        merge_id: 9,
      },
      interests_235: {
        name: 'interests_235',
        label: 'Your Interests',
        helper_text: '',
        type: 'checkbox',
        required: false,
        choices: [],
        audience_field_name: 'Your Interests',
        enabled: false,
        order: null,
        field_type: 'group',
        group_id: 235,
      },
    }).find(function (f) {
      return f.name === fieldName && f.type === 'smsphone';
    });
    var isRequired = smsField ? smsField.required : false;
    var shouldAppendCountryCode = smsNotRequiredRemoveCountryCodeEnabled ? isRequired : true;

    var phoneInput = document.querySelector('#mce-' + fieldName);
    if (phoneInput && defaultProgram.countryCallingCode && shouldAppendCountryCode) {
      phoneInput.value = defaultProgram.countryCallingCode;
    }

    displayFlag?.addEventListener('click', function (e) {
      dropdown.focus();
    });

    dropdown?.addEventListener('change', function () {
      const selectedCountry = this.value;

      if (!selectedCountry || typeof selectedCountry !== 'string') {
        return;
      }

      const flagSpan = displayFlag?.querySelector('#flag-emoji-' + fieldName);
      if (flagSpan) {
        flagSpan.textContent = getCountryUnicodeFlag(selectedCountry);
        flagSpan.setAttribute('aria-label', sanitizeHtml(selectedCountry) + ' flag');
      }

      const selectedProgram = window.MC?.smsPhoneData?.programs.find(function (program) {
        return program && program.countryCode === selectedCountry;
      });

      var smsNotRequiredRemoveCountryCodeEnabled = true;
      var smsField = Object.values({
        FNAME: {
          name: 'FNAME',
          label: 'First Name',
          helper_text: '',
          type: 'text',
          required: false,
          audience_field_name: 'First Name',
          enabled: true,
          order: 0,
          field_type: 'merge',
          merge_id: 1,
        },
        LNAME: {
          name: 'LNAME',
          label: 'Last Name',
          helper_text: '',
          type: 'text',
          required: false,
          audience_field_name: 'Last Name',
          enabled: true,
          order: 1,
          field_type: 'merge',
          merge_id: 2,
        },
        EMAIL: {
          name: 'EMAIL',
          label: 'Email Address',
          helper_text: '',
          merge_id: 0,
          type: 'email',
          required: true,
          audience_field_name: 'Email Address',
          field_type: 'merge',
          enabled: true,
          order: 2,
        },
        ADDRESS: {
          name: 'ADDRESS',
          label: 'Address',
          helper_text: '',
          type: 'address',
          required: false,
          audience_field_name: 'Address',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 3,
          countries: {
            2: 'Albania',
            3: 'Algeria',
            4: 'Andorra',
            5: 'Angola',
            6: 'Argentina',
            7: 'Armenia',
            8: 'Australia',
            9: 'Austria',
            10: 'Azerbaijan',
            11: 'Bahamas',
            12: 'Bahrain',
            13: 'Bangladesh',
            14: 'Barbados',
            15: 'Belarus',
            16: 'Belgium',
            17: 'Belize',
            18: 'Benin',
            19: 'Bermuda',
            20: 'Bhutan',
            21: 'Bolivia',
            22: 'Bosnia and Herzegovina',
            23: 'Botswana',
            24: 'Brazil',
            25: 'Bulgaria',
            26: 'Burkina Faso',
            27: 'Burundi',
            28: 'Cambodia',
            29: 'Cameroon',
            30: 'Canada',
            31: 'Cape Verde',
            32: 'Cayman Islands',
            33: 'Central African Republic',
            34: 'Chad',
            35: 'Chile',
            36: 'China',
            37: 'Colombia',
            38: 'Congo',
            40: 'Croatia',
            41: 'Cyprus',
            42: 'Czech Republic',
            43: 'Denmark',
            44: 'Djibouti',
            45: 'Ecuador',
            46: 'Egypt',
            47: 'El Salvador',
            48: 'Equatorial Guinea',
            49: 'Eritrea',
            50: 'Estonia',
            51: 'Ethiopia',
            52: 'Fiji',
            53: 'Finland',
            54: 'France',
            56: 'Gabon',
            57: 'Gambia',
            58: 'Georgia',
            59: 'Germany',
            60: 'Ghana',
            61: 'Greece',
            62: 'Guam',
            63: 'Guinea',
            64: 'Guinea-Bissau',
            65: 'Guyana',
            66: 'Honduras',
            67: 'Hong Kong',
            68: 'Hungary',
            69: 'Iceland',
            70: 'India',
            71: 'Indonesia',
            74: 'Ireland',
            75: 'Israel',
            76: 'Italy',
            78: 'Japan',
            79: 'Jordan',
            80: 'Kazakhstan',
            81: 'Kenya',
            82: 'Kuwait',
            83: 'Kyrgyzstan',
            84: "Lao People's Democratic Republic",
            85: 'Latvia',
            86: 'Lebanon',
            87: 'Lesotho',
            88: 'Liberia',
            90: 'Liechtenstein',
            91: 'Lithuania',
            92: 'Luxembourg',
            93: 'Macedonia',
            94: 'Madagascar',
            95: 'Malawi',
            96: 'Malaysia',
            97: 'Maldives',
            98: 'Mali',
            99: 'Malta',
            100: 'Mauritania',
            101: 'Mexico',
            102: 'Moldova',
            103: 'Monaco',
            104: 'Mongolia',
            105: 'Morocco',
            106: 'Mozambique',
            107: 'Namibia',
            108: 'Nepal',
            109: 'Netherlands',
            110: 'Netherlands Antilles',
            111: 'New Zealand',
            112: 'Nicaragua',
            113: 'Niger',
            114: 'Nigeria',
            116: 'Norway',
            117: 'Oman',
            118: 'Pakistan',
            119: 'Panama',
            120: 'Paraguay',
            121: 'Peru',
            122: 'Philippines',
            123: 'Poland',
            124: 'Portugal',
            126: 'Qatar',
            127: 'Reunion',
            128: 'Romania',
            129: 'Russia',
            130: 'Rwanda',
            132: 'Samoa (Independent)',
            133: 'Saudi Arabia',
            134: 'Senegal',
            135: 'Seychelles',
            136: 'Sierra Leone',
            137: 'Singapore',
            138: 'Slovakia',
            139: 'Slovenia',
            140: 'Somalia',
            141: 'South Africa',
            142: 'South Korea',
            143: 'Spain',
            144: 'Sri Lanka',
            146: 'Suriname',
            147: 'Swaziland',
            148: 'Sweden',
            149: 'Switzerland',
            152: 'Taiwan',
            153: 'Tanzania',
            154: 'Thailand',
            155: 'Togo',
            156: 'Tunisia',
            157: 'Turkiye',
            158: 'Turkmenistan',
            159: 'Uganda',
            161: 'Ukraine',
            162: 'United Arab Emirates',
            163: 'Uruguay',
            164: 'USA',
            165: 'Uzbekistan',
            166: 'Vatican City State (Holy See)',
            167: 'Venezuela',
            168: 'Vietnam',
            169: 'Virgin Islands (British)',
            170: 'Yemen',
            173: 'Zambia',
            174: 'Zimbabwe',
            175: 'Antigua And Barbuda',
            176: 'Anguilla',
            178: 'American Samoa',
            179: 'Aruba',
            180: 'Brunei Darussalam',
            181: 'Bouvet Island',
            183: 'Cook Islands',
            185: 'Christmas Island',
            187: 'Dominican Republic',
            188: 'Western Sahara',
            189: 'Falkland Islands',
            191: 'Faroe Islands',
            192: 'Grenada',
            193: 'French Guiana',
            194: 'Gibraltar',
            195: 'Greenland',
            196: 'Guadeloupe',
            198: 'Guatemala',
            200: 'Haiti',
            202: 'Jamaica',
            203: 'Kiribati',
            204: 'Comoros',
            205: 'Saint Kitts and Nevis',
            206: 'Saint Lucia',
            207: 'Marshall Islands',
            208: 'Macau',
            210: 'Martinique',
            212: 'Mauritius',
            213: 'New Caledonia',
            214: 'Norfolk Island',
            215: 'Nauru',
            217: 'Niue',
            219: 'Papua New Guinea',
            221: 'Pitcairn',
            222: 'Palau',
            223: 'Solomon Islands',
            225: 'Svalbard and Jan Mayen Islands',
            227: 'San Marino',
            232: 'Tonga',
            233: 'Timor-Leste',
            234: 'Trinidad and Tobago',
            235: 'Tuvalu',
            237: 'Saint Vincent and the Grenadines',
            238: 'Virgin Islands (U.S.)',
            239: 'Vanuatu',
            241: 'Mayotte',
            242: 'Myanmar',
            255: 'Sao Tome and Principe',
            257: 'South Georgia and the South Sandwich Islands',
            260: 'Tajikistan',
            262: 'United Kingdom',
            268: 'Costa Rica',
            270: 'Guernsey',
            272: 'North Korea',
            274: 'Afghanistan',
            275: "Cote D'Ivoire",
            276: 'Cuba',
            277: 'French Polynesia',
            278: 'Iran',
            279: 'Iraq',
            281: 'Libya',
            282: 'Palestine',
            285: 'Syria',
            286: 'Aaland Islands',
            287: 'Turks & Caicos Islands',
            288: 'Jersey  (Channel Islands)',
            289: 'Dominica',
            290: 'Montenegro',
            293: 'Sudan',
            294: 'Montserrat',
            298: 'Curacao',
            302: 'Sint Maarten',
            311: 'South Sudan',
            315: 'Republic of Kosovo',
            318: 'Congo, Democratic Republic of the',
            323: 'Isle of Man',
            324: 'Saint Martin',
            325: 'Bonaire, Saint Eustatius and Saba',
            326: 'Serbia',
          },
          defaultcountry: 164,
        },
        PHONE: {
          name: 'PHONE',
          label: 'Phone Number',
          helper_text: '',
          type: 'phone',
          required: false,
          audience_field_name: 'Phone Number',
          phoneformat: '',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 4,
        },
        BIRTHDAY: {
          name: 'BIRTHDAY',
          label: 'Birthday',
          helper_text: '',
          type: 'birthday',
          required: false,
          audience_field_name: 'Birthday',
          dateformat: 'MM/DD',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 5,
        },
        MMERGE7: {
          name: 'MMERGE7',
          label: 'Area',
          helper_text: '',
          type: 'text',
          required: false,
          audience_field_name: 'Area',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 7,
        },
        MMERGE8: {
          name: 'MMERGE8',
          label: 'Company Name',
          helper_text: '',
          type: 'text',
          required: false,
          audience_field_name: 'Company Name',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 8,
        },
        MMERGE9: {
          name: 'MMERGE9',
          label: 'Company Code',
          helper_text: '',
          type: 'text',
          required: false,
          audience_field_name: 'Company Code',
          enabled: false,
          order: null,
          field_type: 'merge',
          merge_id: 9,
        },
        interests_235: {
          name: 'interests_235',
          label: 'Your Interests',
          helper_text: '',
          type: 'checkbox',
          required: false,
          choices: [],
          audience_field_name: 'Your Interests',
          enabled: false,
          order: null,
          field_type: 'group',
          group_id: 235,
        },
      }).find(function (f) {
        return f.name === fieldName && f.type === 'smsphone';
      });
      var isRequired = smsField ? smsField.required : false;
      var shouldAppendCountryCode = smsNotRequiredRemoveCountryCodeEnabled ? isRequired : true;

      var phoneInput = document.querySelector('#mce-' + fieldName);
      if (phoneInput && selectedProgram.countryCallingCode && shouldAppendCountryCode) {
        phoneInput.value = selectedProgram.countryCallingCode;
      }

      updateSmsLegalText(selectedCountry, fieldName);
      updatePlaceholder(selectedCountry, fieldName);
      updateCountryCodeInstruction(selectedCountry, fieldName);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const smsPhoneFields = document.querySelectorAll('[id^="country-select-"]');

    smsPhoneFields.forEach(function (dropdown) {
      const fieldName = dropdown?.id.replace('country-select-', '');
      initializeSmsPhoneDropdown(fieldName);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  class PageFAQs {
    constructor() {
      this.details = document.querySelectorAll('.page-faqs__item');
      this.init();
    }

    init() {
      this.details.forEach((detail) => {
        const summary = detail.querySelector('.page-faqs__summary');
        const content = detail.querySelector('.page-faqs__content');

        summary.addEventListener('click', (e) => {
          e.preventDefault();

          if (detail.open) {
            this.close(detail, content);
          } else {
            this.open(detail, content);
          }
        });
      });
    }

    open(detail, content) {
      detail.open = true;
      content.style.height = '0';

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';

        content.addEventListener('transitionend', function onTransitionEnd() {
          content.style.height = 'auto';
          content.removeEventListener('transitionend', onTransitionEnd);
        });
      });
    }

    close(detail, content) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.height = '0';
        });
      });

      content.addEventListener('transitionend', function onTransitionEnd() {
        detail.open = false;
        content.removeEventListener('transitionend', onTransitionEnd);
      });
    }
  }

  if (document.querySelector('.page-faqs')) {
    new PageFAQs();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-applications"]) return;
  try {
    
  class ProductApplications {
    constructor(element) {
      this.container = element;
      this.ctaContainer = element.querySelector('[data-cta-container]');

      this.init();
    }

    init() {
      this.updateCTAVisibility();

      document.addEventListener('audience:changed', () => {
        this.updateCTAVisibility();
      });
    }

    updateCTAVisibility() {
      if (!this.ctaContainer) return;

      const STORAGE_KEY = 'bondit_audience';
      const audience = localStorage.getItem(STORAGE_KEY) || 'consumer';

      const consumerCTA = this.ctaContainer.querySelector('[data-consumer-cta]');
      const tradeCTA = this.ctaContainer.querySelector('[data-trade-cta]');

      if (consumerCTA) {
        consumerCTA.style.display = audience === 'consumer' ? 'block' : 'none';
      }

      if (tradeCTA) {
        tradeCTA.style.display = audience === 'trade' ? 'block' : 'none';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productApplicationsElements = document.querySelectorAll('.product-applications');
    productApplicationsElements.forEach((element) => new ProductApplications(element));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
  class ProductTabs {
    constructor(element) {
      this.container = element;
      this.tabs = Array.from(element.querySelectorAll('.product-tabs__tab'));
      this.panels = Array.from(element.querySelectorAll('.product-tabs__panel'));
      this.ctaContainer = element.querySelector('[data-cta-container]');
      this.STORAGE_KEY = 'bondit_audience';

      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });

      this.updateAudienceVisibility();

      document.addEventListener('audience:changed', () => {
        this.updateAudienceVisibility();
      });
    }

    getAudience() {
      return localStorage.getItem(this.STORAGE_KEY) || 'consumer';
    }

    updateAudienceVisibility() {
      const audience = this.getAudience();

      // Handle trade-only tabs
      this.tabs.forEach((tab) => {
        if (tab.hasAttribute('data-trade-only')) {
          tab.style.display = audience === 'trade' ? '' : 'none';
        }
      });

      // Handle trade-only panels
      this.panels.forEach((panel) => {
        if (panel.hasAttribute('data-trade-only')) {
          panel.style.display = audience === 'trade' ? '' : 'none';
        }
      });

      // Ensure a visible tab is active
      this.ensureActiveTab();

      this.updateCTAVisibility();
    }

    ensureActiveTab() {
      const activeTab = this.tabs.find(
        (tab) => tab.classList.contains('product-tabs__tab--active') && tab.style.display !== 'none'
      );

      if (!activeTab) {
        const firstVisibleTab = this.tabs.find((tab) => tab.style.display !== 'none');
        if (firstVisibleTab) {
          firstVisibleTab.click();
        }
      }
    }

    updateCTAVisibility() {
      if (!this.ctaContainer) return;

      const audience = this.getAudience();

      const consumerCTA = this.ctaContainer.querySelector('[data-consumer-cta]');
      const tradeCTA = this.ctaContainer.querySelector('[data-trade-cta]');

      if (consumerCTA) {
        consumerCTA.style.display = audience === 'consumer' ? 'block' : 'none';
      }

      if (tradeCTA) {
        tradeCTA.style.display = audience === 'trade' ? 'block' : 'none';
      }
    }

    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const targetPanel = clickedTab.dataset.tab;

      this.tabs.forEach((tab) => {
        tab.classList.remove('product-tabs__tab--active');
      });

      this.panels.forEach((panel) => {
        panel.classList.remove('product-tabs__panel--active');
      });

      clickedTab.classList.add('product-tabs__tab--active');

      const activePanel = this.panels.find((panel) => panel.dataset.panel === targetPanel);
      if (activePanel) {
        activePanel.classList.add('product-tabs__panel--active');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productTabsElements = document.querySelectorAll('.product-tabs');
    productTabsElements.forEach((element) => new ProductTabs(element));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = element.querySelector('.carousel__track');
      this.slides = Array.from(element.querySelectorAll('.carousel__slide'));
      this.thumbnails = Array.from(element.querySelectorAll('.carousel__thumbnail'));
      this.currentIndex = 0;
      this.startX = 0;
      this.isDragging = false;

      if (this.slides.length <= 1) return;

      this.init();
    }

    init() {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (e) => {
          const index = parseInt(e.currentTarget.dataset.index);
          this.goToSlide(index);
        });
      });

      this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
      this.track.addEventListener('touchend', () => this.handleTouchEnd());

      this.track.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      document.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      document.addEventListener('mouseup', () => this.handleMouseUp());

      document.addEventListener('keydown', (e) => {
        if (!this.carousel.contains(document.activeElement)) return;
        if (e.key === 'ArrowLeft') this.goToPrevious();
        if (e.key === 'ArrowRight') this.goToNext();
      });
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.updateCarousel();
    }

    goToNext() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.updateCarousel();
    }

    goToPrevious() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.updateCarousel();
    }

    updateCarousel() {
      const offset = -this.currentIndex * 100;
      this.track.style.transform = `translateX(${offset}%)`;

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.classList.toggle('carousel__thumbnail--active', index === this.currentIndex);
      });

      const activeThumbnail = this.thumbnails[this.currentIndex];
      if (activeThumbnail) {
        activeThumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
    }

    handleTouchMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.touches[0].clientX;
    }

    handleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;

      const diff = this.startX - this.currentX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    }

    handleMouseDown(e) {
      this.startX = e.clientX;
      this.isDragging = true;
      this.track.style.cursor = 'grabbing';
      e.preventDefault();
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.clientX;
    }

    handleMouseUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.cursor = '';

      const diff = this.startX - this.currentX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach((carousel) => new ProductCarousel(carousel));
  });

  // Variant pricing: update price, compare-at, and ATC button on variant change
  (function () {
    var pricingEl = document.querySelector('[data-product-pricing]');
    if (!pricingEl) return;

    var moneyFormat = pricingEl.getAttribute('data-money-format');
    var priceEl = pricingEl.querySelector('[data-product-price]');
    var compareEl = pricingEl.querySelector('[data-compare-price]');
    var atcBtn = document.querySelector('[data-atc-btn]');
    var atcText = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var skuEl = document.querySelector('[data-product-sku]');
    var skuValueEl = document.querySelector('[data-product-sku-value]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var noDecimals = Math.round(cents / 100).toString();
      var withComma = amount.replace('.', ',');
      var o = '{' + '{';
      var c = '}' + '}';
      return moneyFormat
        .replace(o + 'amount' + c, amount)
        .replace(o + 'amount_no_decimals' + c, noDecimals)
        .replace(o + 'amount_with_comma_separator' + c, withComma)
        .replace(o + 'amount_no_decimals_with_comma_separator' + c, noDecimals);
    }

    document.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (skuEl && skuValueEl) {
        if (variant.sku) {
          skuValueEl.textContent = variant.sku;
          skuEl.style.display = '';
        } else {
          skuEl.style.display = 'none';
        }
      }

      if (atcBtn && atcText) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          atcBtn.classList.remove('product-form__submit--soldout');
          atcText.textContent = 'Add to cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.classList.add('product-form__submit--soldout');
          atcText.textContent = 'Sold out';
        }
      }

      var qtyInput = document.querySelector('#quantity');
      if (qtyInput && variant.quantity_rule) {
        var rule = variant.quantity_rule;
        qtyInput.min = rule.min;
        qtyInput.step = rule.increment;
        if (rule.max) {
          qtyInput.max = rule.max;
        } else {
          qtyInput.removeAttribute('max');
        }
        qtyInput.value = rule.min;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"]) return;
  try {
    
  class RecentlyViewedProducts {
    constructor(element) {
      this.section = element;
      this.container = element.querySelector('[data-products-container]');
      this.currentProductId = element.dataset.currentProductId;
      this.currentProductHandle = element.dataset.currentProductHandle;
      this.storageKey = 'bondit_recently_viewed';
      this.maxProducts = 2;

      this.init();
    }

    init() {
      // Track current product view
      this.trackProductView();

      // Load and display recently viewed products
      this.loadRecentlyViewed();
    }

    trackProductView() {
      if (!this.currentProductHandle) return;

      let viewedProducts = this.getViewedProducts();

      // Remove current product if it exists
      viewedProducts = viewedProducts.filter((handle) => handle !== this.currentProductHandle);

      // Add current product to the beginning
      viewedProducts.unshift(this.currentProductHandle);

      // Keep only the most recent products (store more than we display for better results)
      viewedProducts = viewedProducts.slice(0, 10);

      // Save to localStorage
      localStorage.setItem(this.storageKey, JSON.stringify(viewedProducts));
    }

    getViewedProducts() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        return [];
      }
    }

    async loadRecentlyViewed() {
      let viewedProducts = this.getViewedProducts();

      // Remove current product from display
      viewedProducts = viewedProducts.filter((handle) => handle !== this.currentProductHandle);

      // Get only the number we need
      const productHandles = viewedProducts.slice(0, this.maxProducts);

      if (productHandles.length === 0) {
        this.section.style.display = 'none';
        return;
      }

      // Fetch product data for each handle
      const products = await Promise.all(productHandles.map((handle) => this.fetchProduct(handle)));

      // Filter out any failed fetches
      const validProducts = products.filter((p) => p !== null);

      if (validProducts.length === 0) {
        this.section.style.display = 'none';
        return;
      }

      // Render products
      this.renderProducts(validProducts);
    }

    async fetchProduct(productHandle) {
      try {
        const response = await fetch(`/products/${productHandle}.js`, { credentials: 'same-origin' });
        if (!response.ok) return null;
        return await response.json();
      } catch (e) {
        console.error('Failed to fetch product:', productHandle, e);
        return null;
      }
    }

    renderProducts(products) {
      this.container.innerHTML = products.map((product) => this.renderProductCard(product)).join('');
    }

    renderProductCard(product) {
      const description = this.stripHtml(product.description).substring(0, 200);
      const imageUrl = product.featured_image ? product.featured_image : '';

      return `
        <article class="product-card-horizontal">
          <div class="product-card-horizontal__content">
            <h3 class="product-card-horizontal__title">
              ${product.title}
            </h3>
            ${
              description
                ? `
              <p class="product-card-horizontal__description">
                ${description}${description.length >= 200 ? '...' : ''}
              </p>
            `
                : ''
            }
            <span class="product-card-horizontal__link">
              View Product
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
          <div class="product-card-horizontal__image">
            ${
              imageUrl
                ? `
              <img src="${imageUrl}" alt="${product.title}" loading="lazy">
            `
                : ''
            }
          </div>
          <a href="${product.url}">View ${product.title}</a>
        </article>
      `;
    }

    stripHtml(html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.recently-viewed-products');
    sections.forEach((section) => new RecentlyViewedProducts(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var grid = document.getElementById('search-results-grid');
    var loadMoreContainer = document.getElementById('search-load-more');

    if (!loadMoreContainer || !grid) return;

    loadMoreContainer.addEventListener('click', function (e) {
      e.preventDefault();

      var link = loadMoreContainer.querySelector('a');
      if (!link) return;

      var nextUrl = link.getAttribute('href');
      if (!nextUrl) return;

      link.textContent = 'Loading\u2026';
      link.style.pointerEvents = 'none';

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('search-results-grid');
          if (newGrid) {
            Array.from(newGrid.children).forEach(function (child) {
              grid.appendChild(child.cloneNode(true));
            });
          }

          var newLoadMore = doc.getElementById('search-load-more');
          var newLink = newLoadMore ? newLoadMore.querySelector('a') : null;

          if (newLink) {
            link.setAttribute('href', newLink.getAttribute('href'));
            link.textContent = 'Load more';
            link.style.pointerEvents = '';
          } else {
            loadMoreContainer.remove();
          }
        })
        .catch(function (err) {
          console.error('Search load more error:', err);
          link.textContent = 'Load more';
          link.style.pointerEvents = '';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Haversine distance (returns miles) ---
    function haversineMiles(lat1, lon1, lat2, lon2) {
      var R = 3958.8;
      var dLat = ((lat2 - lat1) * Math.PI) / 180;
      var dLon = ((lon2 - lon1) * Math.PI) / 180;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // --- Init each section ---
    document.querySelectorAll('[id^="stockist-finder-"]').forEach(function (section) {
      var form = section.querySelector('.stockist-finder__form');
      var input = section.querySelector('.stockist-finder__input');
      var grid = section.querySelector('.stockist-finder__grid');
      var emptyState = section.querySelector('.stockist-finder__empty');
      var loadingState = section.querySelector('.stockist-finder__loading');
      var loadMoreWrap = section.querySelector('.stockist-finder__load-more');
      var loadMoreBtn = section.querySelector('.stockist-finder__load-more-button');

      var stockistsUrl = section.dataset.stockistsUrl || '';
      var apiKey = section.dataset.googleMapsKey || '';
      var searchRadius = parseFloat(section.dataset.searchRadius) || 25; // miles
      var resultsPerPage = parseInt(section.dataset.resultsPerPage, 10) || 8;

      var allStockists = []; // full geocoded dataset
      var allResults = []; // filtered + sorted after a search
      var currentPage = 0;
      var debounceTimer = null;
      var DEBOUNCE_MS = 250;
      var suggestionsList = section.querySelector('.stockist-finder__suggestions');
      var lastSearchedQuery = '';
      var activeIndex = -1;

      // Fetch stockists.json once
      if (stockistsUrl) {
        fetch(stockistsUrl, { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            allStockists = (Array.isArray(data) ? data : []).filter(function (s) {
              return s.lat != null && s.lng != null;
            });
          })
          .catch(function (err) {
            console.error('Stockist data failed to load:', err);
          });
      }

      // --- UI helpers ---
      function showLoading() {
        loadingState.hidden = false;
        emptyState.hidden = true;
        grid.innerHTML = '';
        loadMoreWrap.hidden = true;
      }
      function hideLoading() {
        loadingState.hidden = true;
      }
      function showEmpty() {
        emptyState.hidden = false;
        loadMoreWrap.hidden = true;
      }

      // --- Suggestions dropdown ---
      function showSuggestions(suggestions) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        suggestionsList.innerHTML = '';
        if (!suggestions.length) {
          hideSuggestions();
          return;
        }
        suggestions.forEach(function (s, i) {
          var li = document.createElement('li');
          li.className = 'stockist-finder__suggestion';
          li.textContent = s.text;
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', 'false');
          li.id = suggestionsList.id + '-option-' + i;
          li.dataset.placeId = s.placeId;
          li.addEventListener('mousedown', function (e) {
            e.preventDefault(); // keep focus on input until we're done
            input.value = s.text;
            lastSearchedQuery = s.text;
            hideSuggestions();
            showLoading();
            fetchPlaceDetails(s.placeId);
          });
          suggestionsList.appendChild(li);
        });
        suggestionsList.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function hideSuggestions() {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        suggestionsList.hidden = true;
        suggestionsList.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function setActiveIndex(items) {
        items.forEach(function (item, i) {
          item.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
          if (i === activeIndex) {
            item.scrollIntoView({ block: 'nearest' });
            input.setAttribute('aria-activedescendant', item.id);
          }
        });
        if (activeIndex < 0) input.removeAttribute('aria-activedescendant');
      }

      // --- Places Autocomplete (New REST API) ---
      function fetchSuggestions(query) {
        if (!query || query.length < 2 || !apiKey) {
          hideSuggestions();
          return;
        }
        fetch('https://places.googleapis.com/v1/places:autocomplete?key=' + apiKey, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ input: query, includedRegionCodes: ['GB'] }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var suggestions = (data.suggestions || []).map(function (s) {
              return {
                placeId: s.placePrediction.placeId,
                text: s.placePrediction.text.text,
              };
            });
            showSuggestions(suggestions);
          })
          .catch(function () {
            hideSuggestions();
          });
      }

      // --- Places Details (New REST API) — fetch lat/lng for selected place ---
      function fetchPlaceDetails(placeId) {
        fetch('https://places.googleapis.com/v1/places/' + placeId + '?fields=location&key=' + apiKey)
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.location) {
              runSearch(data.location.latitude, data.location.longitude);
            } else {
              hideLoading();
              showEmpty();
            }
          })
          .catch(function () {
            hideLoading();
            showEmpty();
          });
      }

      // --- Card builder ---
      function buildCard(s) {
        var card = document.createElement('article');
        card.className = 'stockist-finder__card';

        var name = document.createElement('h3');
        name.className = 'stockist-finder__card-name';
        name.textContent = s.name || '';
        card.appendChild(name);

        var addrParts = [s.address_1, s.address_2, s.city, s.county, s.postcode].filter(Boolean);
        if (addrParts.length) {
          var addr = document.createElement('p');
          addr.className = 'stockist-finder__card-address';
          addr.textContent = addrParts.join(', ');
          card.appendChild(addr);
        }

        if (s.phone) {
          var ph = document.createElement('p');
          ph.className = 'stockist-finder__card-phone';
          var a = document.createElement('a');
          a.href = 'tel:' + s.phone.replace(/\s/g, '');
          a.textContent = s.phone;
          ph.appendChild(a);
          card.appendChild(ph);
        }

        if (s._distance != null) {
          var dist = document.createElement('p');
          dist.className = 'stockist-finder__card-distance';
          dist.textContent = s._distance.toFixed(1) + ' miles away';
          card.appendChild(dist);
        }

        return card;
      }

      // --- Render a page of results ---
      function renderPage(append) {
        if (!append) grid.innerHTML = '';
        var start = (currentPage - 1) * resultsPerPage;
        var end = start + resultsPerPage;
        allResults.slice(start, end).forEach(function (s) {
          grid.appendChild(buildCard(s));
        });
        loadMoreWrap.hidden = end >= allResults.length;
      }

      // --- Run haversine against loaded stockists ---
      function runSearch(lat, lng) {
        var sorted = allStockists
          .map(function (s) {
            return Object.assign({}, s, { _distance: haversineMiles(lat, lng, s.lat, s.lng) });
          })
          .filter(function (s) {
            return s._distance <= searchRadius;
          })
          .sort(function (a, b) {
            return a._distance - b._distance;
          });

        // Pin the single closest Selco to the top
        var selcoIndex = sorted.findIndex(function (s) {
          return s.name && s.name.indexOf('Selco') === 0;
        });
        if (selcoIndex > 0) {
          var selco = sorted.splice(selcoIndex, 1)[0];
          sorted.unshift(selco);
        }
        allResults = sorted;

        hideLoading();
        if (allResults.length === 0) {
          showEmpty();
        } else {
          currentPage = 1;
          renderPage(false);
        }
      }

      // --- Geocoding REST API fallback (form submit without suggestion pick) ---
      function geocodeAndSearch(query) {
        if (!apiKey) {
          hideLoading();
          showEmpty();
          return;
        }
        fetch(
          'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            encodeURIComponent(query) +
            '&components=country:GB&key=' +
            apiKey
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status === 'OK' && data.results[0]) {
              var loc = data.results[0].geometry.location;
              runSearch(loc.lat, loc.lng);
            } else {
              hideLoading();
              showEmpty();
            }
          })
          .catch(function () {
            hideLoading();
            showEmpty();
          });
      }

      // --- Keyboard navigation in suggestions ---
      input.addEventListener('keydown', function (e) {
        if (suggestionsList.hidden) return;
        var items = Array.prototype.slice.call(suggestionsList.querySelectorAll('[data-place-id]'));
        if (!items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, items.length - 1);
          setActiveIndex(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, -1);
          setActiveIndex(items);
        } else if (e.key === 'Escape') {
          hideSuggestions();
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          var selected = items[activeIndex];
          input.value = selected.textContent;
          lastSearchedQuery = selected.textContent;
          hideSuggestions();
          showLoading();
          fetchPlaceDetails(selected.dataset.placeId);
        }
      });

      // --- Debounced input → autocomplete suggestions ---
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          fetchSuggestions(input.value.trim());
        }, DEBOUNCE_MS);
      });

      input.addEventListener('blur', function () {
        // Small delay so the mousedown on a suggestion fires before we hide the list
        setTimeout(hideSuggestions, 150);
      });

      // --- Form submit — pick first suggestion if visible, else geocode ---
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.trim();
        if (!q) return;

        // Query unchanged and results already displayed — do nothing
        if (q === lastSearchedQuery && allResults.length > 0) {
          hideSuggestions();
          return;
        }

        // Suggestions visible — promote the first one instead of geocoding raw text
        var firstSuggestion = suggestionsList.querySelector('[data-place-id]');
        if (firstSuggestion && !suggestionsList.hidden) {
          input.value = firstSuggestion.textContent;
          lastSearchedQuery = firstSuggestion.textContent;
          hideSuggestions();
          showLoading();
          fetchPlaceDetails(firstSuggestion.dataset.placeId);
          return;
        }

        lastSearchedQuery = q;
        hideSuggestions();
        showLoading();
        geocodeAndSearch(q);
      });

      // --- Load more ---
      loadMoreBtn.addEventListener('click', function () {
        currentPage++;
        renderPage(true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-clients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials() {
      if (typeof gsap === 'undefined' || typeof SplitText === 'undefined') {
        setTimeout(initTestimonials, 100);
        return;
      }

      gsap.registerPlugin(SplitText);

      document.querySelectorAll('[data-testimonials-carousel]').forEach(function (carousel) {
        const quotesContainer = carousel.querySelector('.testimonials-clients__quotes');
        const authorsContainer = carousel.querySelector('.testimonials-clients__authors');
        const quotes = carousel.querySelectorAll('[data-quote-index]');
        const authors = carousel.querySelectorAll('[data-author-index]');
        const prevBtn = carousel.querySelector('[data-testimonial-prev] button');
        const nextBtn = carousel.querySelector('[data-testimonial-next] button');
        let currentIndex = 0;
        let currentTimeline = null;
        let currentSplit = null;

        const charDelay = 0.04;
        const pauseAfterComplete = 2.5;

        function setContainerHeights() {
          let maxQuoteHeight = 0;
          let maxAuthorHeight = 0;

          quotes.forEach(function (quote, index) {
            const text = quote.dataset.quoteText || '';
            const wordsContainer = quote.querySelector('.testimonials-clients__quote-words');
            if (wordsContainer && !wordsContainer.textContent.trim()) {
              wordsContainer.textContent = '"' + text + '"';
            }

            const prevClass = quote.className;
            quote.className = 'testimonials-clients__quote testimonials-clients__quote--active';
            const height = quote.offsetHeight;
            quote.className = prevClass;
            if (height > maxQuoteHeight) maxQuoteHeight = height;
          });

          authors.forEach(function (author) {
            const prevClass = author.className;
            author.className = 'testimonials-clients__author testimonials-clients__author--active';
            const height = author.offsetHeight;
            author.className = prevClass;
            if (height > maxAuthorHeight) maxAuthorHeight = height;
          });

          if (quotesContainer && maxQuoteHeight > 0) {
            quotesContainer.style.minHeight = maxQuoteHeight + 'px';
          }
          if (authorsContainer && maxAuthorHeight > 0) {
            authorsContainer.style.minHeight = maxAuthorHeight + 'px';
          }
        }

        setContainerHeights();
        window.addEventListener('resize', setContainerHeights);

        function prepareQuote(quoteEl) {
          const text = quoteEl.dataset.quoteText || '';
          const wordsContainer = quoteEl.querySelector('.testimonials-clients__quote-words');
          if (!wordsContainer) return null;

          wordsContainer.innerHTML = '"' + text + '"';

          if (currentSplit) {
            currentSplit.revert();
          }

          currentSplit = new SplitText(wordsContainer, {
            type: 'chars,words',
            charsClass: 'char',
            wordsClass: 'word',
          });

          return currentSplit.chars;
        }

        function showTestimonial(index, animate) {
          if (currentTimeline) {
            currentTimeline.kill();
            currentTimeline = null;
          }

          const prevQuote = quotes[currentIndex];
          const nextQuote = quotes[index];
          const prevAuthor = authors[currentIndex];
          const nextAuthor = authors[index];

          if (animate !== false && currentIndex !== index) {
            currentTimeline = gsap.timeline({
              onComplete: function () {
                if (quotes.length > 1) {
                  const nextIdx = index === quotes.length - 1 ? 0 : index + 1;
                  showTestimonial(nextIdx, true);
                }
              },
            });

            // Fade out previous quote and author
            currentTimeline.to([prevQuote, prevAuthor], {
              opacity: 0,
              duration: 0.6,
              ease: 'power2.inOut',
              onComplete: function () {
                prevQuote.classList.remove('testimonials-clients__quote--active');
                prevAuthor.classList.remove('testimonials-clients__author--active');
              },
            });

            // Prepare next quote
            const chars = prepareQuote(nextQuote);
            if (chars) {
              gsap.set(chars, { opacity: 0.4 });
            }

            // Add active classes
            currentTimeline.add(function () {
              nextQuote.classList.add('testimonials-clients__quote--active');
              nextAuthor.classList.add('testimonials-clients__author--active');
            });

            // Fade in next quote and author
            currentTimeline.to(
              [nextQuote, nextAuthor],
              {
                opacity: 1,
                duration: 0.6,
                ease: 'power2.inOut',
              },
              '-=0.3'
            );

            // Animate quote characters
            if (chars) {
              currentTimeline.to(
                chars,
                {
                  opacity: 1,
                  duration: 0.35,
                  stagger: charDelay,
                  ease: 'none',
                },
                '-=0.3'
              );
            }

            currentTimeline.to({}, { duration: pauseAfterComplete });
          } else {
            // Initial setup
            quotes.forEach(function (quote, i) {
              quote.classList.toggle('testimonials-clients__quote--active', i === index);
              gsap.set(quote, { opacity: i === index ? 1 : 0 });
            });
            authors.forEach(function (author, i) {
              author.classList.toggle('testimonials-clients__author--active', i === index);
              gsap.set(author, { opacity: i === index ? 1 : 0 });
            });

            const chars = prepareQuote(nextQuote);

            if (animate !== false && chars) {
              gsap.set(chars, { opacity: 0.4 });

              currentTimeline = gsap.timeline({
                onComplete: function () {
                  if (quotes.length > 1) {
                    const nextIdx = index === quotes.length - 1 ? 0 : index + 1;
                    showTestimonial(nextIdx, true);
                  }
                },
              });

              currentTimeline.to(chars, {
                opacity: 1,
                duration: 0.15,
                stagger: charDelay,
                ease: 'none',
              });

              currentTimeline.to({}, { duration: pauseAfterComplete });
            }
          }

          currentIndex = index;
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            const newIndex = currentIndex === 0 ? quotes.length - 1 : currentIndex - 1;
            showTestimonial(newIndex, true);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            const newIndex = currentIndex === quotes.length - 1 ? 0 : currentIndex + 1;
            showTestimonial(newIndex, true);
          });
        }

        if (quotes.length > 0) {
          showTestimonial(0, true);
        }
      });
    }

    function initWhenReady() {
      document.fonts.ready.then(initTestimonials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhenReady);
    } else {
      initWhenReady();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials() {
      if (typeof gsap === 'undefined' || typeof SplitText === 'undefined') {
        setTimeout(initTestimonials, 100);
        return;
      }

      gsap.registerPlugin(SplitText);

      document.querySelectorAll('[data-testimonials-carousel]').forEach(function (carousel) {
        const quotesContainer = carousel.querySelector('.testimonials__quotes');
        const quotes = carousel.querySelectorAll('[data-quote-index]');
        const prevBtn = carousel.querySelector('[data-testimonial-prev] button');
        const nextBtn = carousel.querySelector('[data-testimonial-next] button');
        let currentIndex = 0;
        let currentTimeline = null;
        let currentSplit = null;

        // Average reading speed: ~250 words per minute
        // Average word length: ~5 characters
        // So roughly 1250 characters per minute = ~48ms per character
        const charDelay = 0.04;
        const pauseAfterComplete = 2.5;

        // Calculate max height of all quotes to prevent jitter
        function setContainerHeight() {
          let maxHeight = 0;
          quotes.forEach(function (quote) {
            // Ensure text content is populated for accurate measurement
            const text = quote.dataset.quoteText || '';
            const wordsContainer = quote.querySelector('.testimonials__quote-words');
            if (wordsContainer && !wordsContainer.textContent.trim()) {
              wordsContainer.textContent = '"' + text + '"';
            }

            quote.classList.add('testimonials__quote--measuring');
            const height = quote.offsetHeight;
            quote.classList.remove('testimonials__quote--measuring');
            if (height > maxHeight) maxHeight = height;
          });
          if (quotesContainer && maxHeight > 0) {
            quotesContainer.style.minHeight = maxHeight + 'px';
          }
        }

        setContainerHeight();
        window.addEventListener('resize', setContainerHeight);

        function prepareQuote(quoteEl) {
          const text = quoteEl.dataset.quoteText || '';
          const wordsContainer = quoteEl.querySelector('.testimonials__quote-words');
          if (!wordsContainer) return null;

          wordsContainer.innerHTML = text;

          if (currentSplit) {
            currentSplit.revert();
          }

          currentSplit = new SplitText(wordsContainer, {
            type: 'chars,words',
            charsClass: 'char',
            wordsClass: 'word',
          });

          return currentSplit.chars;
        }

        function showQuote(index, animate) {
          if (currentTimeline) {
            currentTimeline.kill();
            currentTimeline = null;
          }

          const prevQuote = quotes[currentIndex];
          const nextQuote = quotes[index];

          if (animate !== false && prevQuote !== nextQuote) {
            currentTimeline = gsap.timeline({
              onComplete: function () {
                if (quotes.length > 1) {
                  const nextIdx = index === quotes.length - 1 ? 0 : index + 1;
                  showQuote(nextIdx, true);
                }
              },
            });

            currentTimeline.to(prevQuote, {
              opacity: 0,
              duration: 0.6,
              ease: 'power2.inOut',
              onComplete: function () {
                prevQuote.classList.remove('testimonials__quote--active');
              },
            });

            const chars = prepareQuote(nextQuote);
            if (chars) {
              gsap.set(chars, { opacity: 0.4 });
            }

            currentTimeline.add(function () {
              nextQuote.classList.add('testimonials__quote--active');
            });

            currentTimeline.to(nextQuote, {
              opacity: 1,
              duration: 0.6,
              ease: 'power2.inOut',
            });

            if (chars) {
              currentTimeline.to(
                chars,
                {
                  opacity: 1,
                  duration: 0.35,
                  stagger: charDelay,
                  ease: 'none',
                },
                '-=0.3'
              );
            }

            currentTimeline.to({}, { duration: pauseAfterComplete });
          } else {
            quotes.forEach(function (quote, i) {
              quote.classList.toggle('testimonials__quote--active', i === index);
              gsap.set(quote, { opacity: i === index ? 1 : 0 });
            });

            const chars = prepareQuote(nextQuote);

            if (animate !== false && chars) {
              gsap.set(chars, { opacity: 0.4 });

              currentTimeline = gsap.timeline({
                onComplete: function () {
                  if (quotes.length > 1) {
                    const nextIdx = index === quotes.length - 1 ? 0 : index + 1;
                    showQuote(nextIdx, true);
                  }
                },
              });

              currentTimeline.to(chars, {
                opacity: 1,
                duration: 0.15,
                stagger: charDelay,
                ease: 'none',
              });

              currentTimeline.to({}, { duration: pauseAfterComplete });
            }
          }

          currentIndex = index;
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            const newIndex = currentIndex === 0 ? quotes.length - 1 : currentIndex - 1;
            showQuote(newIndex, true);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            const newIndex = currentIndex === quotes.length - 1 ? 0 : currentIndex + 1;
            showQuote(newIndex, true);
          });
        }

        if (quotes.length > 0) {
          showQuote(0, true);
        }
      });
    }

    function initWhenReady() {
      document.fonts.ready.then(initTestimonials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhenReady);
    } else {
      initWhenReady();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-quote"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-quote]').forEach(function (container) {
    var video = container.querySelector('.video-quote__video');
    var play = container.querySelector('.video-quote__play');
    if (!video || !play) return;

    play.addEventListener('click', function () {
      video.play();
    });
    video.addEventListener('play', function () {
      container.classList.add('is-playing');
    });
    video.addEventListener('pause', function () {
      container.classList.remove('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
